/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A location in a connection that can be used for resuming pagination. */
  Cursor: any;
  /** The day, does not include a time. */
  Date: any;
  /**
   * A point in time as described by the [ISO
   * 8601](https://en.wikipedia.org/wiki/ISO_8601) standard. May or may not include a timezone.
   */
  Datetime: any;
  /** A universally unique identifier as defined by [RFC 4122](https://tools.ietf.org/html/rfc4122). */
  UUID: any;
};

/** All input for the `addRemainingAddableUserCountByUserId` mutation. */
export type AddRemainingAddableUserCountByUserIdInput = {
  _userId?: InputMaybe<Scalars['UUID']>;
  _value?: InputMaybe<Scalars['Int']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our `addRemainingAddableUserCountByUserId` mutation. */
export type AddRemainingAddableUserCountByUserIdPayload = {
  __typename?: 'AddRemainingAddableUserCountByUserIdPayload';
  _user?: Maybe<User>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge?: Maybe<UsersEdge>;
};


/** The output of our `addRemainingAddableUserCountByUserId` mutation. */
export type AddRemainingAddableUserCountByUserIdPayloadUserEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** All input for the create `CustomShift` mutation. */
export type CreateCustomShiftInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `CustomShift` to be created by this mutation. */
  customShift: CustomShiftInput;
};

/** The output of our create `CustomShift` mutation. */
export type CreateCustomShiftPayload = {
  __typename?: 'CreateCustomShiftPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `CustomShift` that was created by this mutation. */
  customShift?: Maybe<CustomShift>;
  /** An edge for our `CustomShift`. May be used by Relay 1. */
  customShiftEdge?: Maybe<CustomShiftsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Workplace` that is related to this `CustomShift`. */
  workplaceByWorkplaceId?: Maybe<Workplace>;
};


/** The output of our create `CustomShift` mutation. */
export type CreateCustomShiftPayloadCustomShiftEdgeArgs = {
  orderBy?: InputMaybe<Array<CustomShiftsOrderBy>>;
};

/** All input for the create `Device` mutation. */
export type CreateDeviceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Device` to be created by this mutation. */
  device: DeviceInput;
};

/** The output of our create `Device` mutation. */
export type CreateDevicePayload = {
  __typename?: 'CreateDevicePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Device` that was created by this mutation. */
  device?: Maybe<Device>;
  /** An edge for our `Device`. May be used by Relay 1. */
  deviceEdge?: Maybe<DevicesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Device`. */
  userByUserId?: Maybe<User>;
};


/** The output of our create `Device` mutation. */
export type CreateDevicePayloadDeviceEdgeArgs = {
  orderBy?: InputMaybe<Array<DevicesOrderBy>>;
};

/** All input for the create `Memo` mutation. */
export type CreateMemoInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Memo` to be created by this mutation. */
  memo: MemoInput;
};

/** The output of our create `Memo` mutation. */
export type CreateMemoPayload = {
  __typename?: 'CreateMemoPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Memo` that was created by this mutation. */
  memo?: Maybe<Memo>;
  /** An edge for our `Memo`. May be used by Relay 1. */
  memoEdge?: Maybe<MemosEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Workplace` that is related to this `Memo`. */
  workplaceByWorkplaceId?: Maybe<Workplace>;
};


/** The output of our create `Memo` mutation. */
export type CreateMemoPayloadMemoEdgeArgs = {
  orderBy?: InputMaybe<Array<MemosOrderBy>>;
};

/** All input for the create `Pgmigration` mutation. */
export type CreatePgmigrationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Pgmigration` to be created by this mutation. */
  pgmigration: PgmigrationInput;
};

/** The output of our create `Pgmigration` mutation. */
export type CreatePgmigrationPayload = {
  __typename?: 'CreatePgmigrationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Pgmigration` that was created by this mutation. */
  pgmigration?: Maybe<Pgmigration>;
  /** An edge for our `Pgmigration`. May be used by Relay 1. */
  pgmigrationEdge?: Maybe<PgmigrationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `Pgmigration` mutation. */
export type CreatePgmigrationPayloadPgmigrationEdgeArgs = {
  orderBy?: InputMaybe<Array<PgmigrationsOrderBy>>;
};

/** All input for the create `_PrismaMigration` mutation. */
export type CreatePrismaMigrationInput = {
  /** The `_PrismaMigration` to be created by this mutation. */
  _prismaMigration: _PrismaMigrationInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our create `_PrismaMigration` mutation. */
export type CreatePrismaMigrationPayload = {
  __typename?: 'CreatePrismaMigrationPayload';
  /** The `_PrismaMigration` that was created by this mutation. */
  _prismaMigration?: Maybe<_PrismaMigration>;
  /** An edge for our `_PrismaMigration`. May be used by Relay 1. */
  _prismaMigrationEdge?: Maybe<_PrismaMigrationsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `_PrismaMigration` mutation. */
export type CreatePrismaMigrationPayload_PrismaMigrationEdgeArgs = {
  orderBy?: InputMaybe<Array<_PrismaMigrationsOrderBy>>;
};

/** All input for the create `Shift` mutation. */
export type CreateShiftInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Shift` to be created by this mutation. */
  shift: ShiftInput;
};

/** The output of our create `Shift` mutation. */
export type CreateShiftPayload = {
  __typename?: 'CreateShiftPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `CustomShift` that is related to this `Shift`. */
  customShiftByCustomShiftId?: Maybe<CustomShift>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Shift` that was created by this mutation. */
  shift?: Maybe<Shift>;
  /** An edge for our `Shift`. May be used by Relay 1. */
  shiftEdge?: Maybe<ShiftsEdge>;
  /** Reads a single `ShiftSetting` that is related to this `Shift`. */
  shiftSettingByShiftSettingId?: Maybe<ShiftSetting>;
  /** Reads a single `Workplace` that is related to this `Shift`. */
  workplaceByWorkplaceId?: Maybe<Workplace>;
  /** Reads a single `WorkplaceUser` that is related to this `Shift`. */
  workplaceUserByWorkplaceUserId?: Maybe<WorkplaceUser>;
};


/** The output of our create `Shift` mutation. */
export type CreateShiftPayloadShiftEdgeArgs = {
  orderBy?: InputMaybe<Array<ShiftsOrderBy>>;
};

/** All input for the create `ShiftSetting` mutation. */
export type CreateShiftSettingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ShiftSetting` to be created by this mutation. */
  shiftSetting: ShiftSettingInput;
};

/** The output of our create `ShiftSetting` mutation. */
export type CreateShiftSettingPayload = {
  __typename?: 'CreateShiftSettingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `ShiftSetting` that was created by this mutation. */
  shiftSetting?: Maybe<ShiftSetting>;
  /** An edge for our `ShiftSetting`. May be used by Relay 1. */
  shiftSettingEdge?: Maybe<ShiftSettingsEdge>;
  /** Reads a single `Workplace` that is related to this `ShiftSetting`. */
  workplaceByWorkplaceId?: Maybe<Workplace>;
};


/** The output of our create `ShiftSetting` mutation. */
export type CreateShiftSettingPayloadShiftSettingEdgeArgs = {
  orderBy?: InputMaybe<Array<ShiftSettingsOrderBy>>;
};

/** All input for the create `User` mutation. */
export type CreateUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `User` to be created by this mutation. */
  user: UserInput;
};

/** The output of our create `User` mutation. */
export type CreateUserPayload = {
  __typename?: 'CreateUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `User` that was created by this mutation. */
  user?: Maybe<User>;
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge?: Maybe<UsersEdge>;
};


/** The output of our create `User` mutation. */
export type CreateUserPayloadUserEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** All input for the create `Workplace` mutation. */
export type CreateWorkplaceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Workplace` to be created by this mutation. */
  workplace: WorkplaceInput;
};

/** The output of our create `Workplace` mutation. */
export type CreateWorkplacePayload = {
  __typename?: 'CreateWorkplacePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Workplace` that was created by this mutation. */
  workplace?: Maybe<Workplace>;
  /** An edge for our `Workplace`. May be used by Relay 1. */
  workplaceEdge?: Maybe<WorkplacesEdge>;
};


/** The output of our create `Workplace` mutation. */
export type CreateWorkplacePayloadWorkplaceEdgeArgs = {
  orderBy?: InputMaybe<Array<WorkplacesOrderBy>>;
};

/** All input for the create `WorkplaceUser` mutation. */
export type CreateWorkplaceUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `WorkplaceUser` to be created by this mutation. */
  workplaceUser: WorkplaceUserInput;
};

/** The output of our create `WorkplaceUser` mutation. */
export type CreateWorkplaceUserPayload = {
  __typename?: 'CreateWorkplaceUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `WorkplaceUser`. */
  userByUserId?: Maybe<User>;
  /** Reads a single `Workplace` that is related to this `WorkplaceUser`. */
  workplaceByWorkplaceId?: Maybe<Workplace>;
  /** The `WorkplaceUser` that was created by this mutation. */
  workplaceUser?: Maybe<WorkplaceUser>;
  /** An edge for our `WorkplaceUser`. May be used by Relay 1. */
  workplaceUserEdge?: Maybe<WorkplaceUsersEdge>;
};


/** The output of our create `WorkplaceUser` mutation. */
export type CreateWorkplaceUserPayloadWorkplaceUserEdgeArgs = {
  orderBy?: InputMaybe<Array<WorkplaceUsersOrderBy>>;
};

export type CustomShift = Node & {
  __typename?: 'CustomShift';
  createdAt: Scalars['Datetime'];
  hexColor: Scalars['String'];
  id: Scalars['UUID'];
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `Shift`. */
  shiftsByCustomShiftId: ShiftsConnection;
  updatedAt: Scalars['Datetime'];
  /** Reads a single `Workplace` that is related to this `CustomShift`. */
  workplaceByWorkplaceId?: Maybe<Workplace>;
  workplaceId: Scalars['UUID'];
};


export type CustomShiftShiftsByCustomShiftIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ShiftCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ShiftsOrderBy>>;
};

/**
 * A condition to be used against `CustomShift` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type CustomShiftCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `workplaceId` field. */
  workplaceId?: InputMaybe<Scalars['UUID']>;
};

/** An input for mutations affecting `CustomShift` */
export type CustomShiftInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  hexColor: Scalars['String'];
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  workplaceId: Scalars['UUID'];
};

/** Represents an update to a `CustomShift`. Fields that are set will be updated. */
export type CustomShiftPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  hexColor?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `CustomShift` values. */
export type CustomShiftsConnection = {
  __typename?: 'CustomShiftsConnection';
  /** A list of edges which contains the `CustomShift` and cursor to aid in pagination. */
  edges: Array<CustomShiftsEdge>;
  /** A list of `CustomShift` objects. */
  nodes: Array<CustomShift>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CustomShift` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `CustomShift` edge in the connection. */
export type CustomShiftsEdge = {
  __typename?: 'CustomShiftsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `CustomShift` at the end of the edge. */
  node: CustomShift;
};

/** Methods to use when ordering `CustomShift`. */
export enum CustomShiftsOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  WorkplaceIdAsc = 'WORKPLACE_ID_ASC',
  WorkplaceIdDesc = 'WORKPLACE_ID_DESC'
}

/** All input for the `decrementRemainingAddableUserCountByUserId` mutation. */
export type DecrementRemainingAddableUserCountByUserIdInput = {
  _userId?: InputMaybe<Scalars['UUID']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our `decrementRemainingAddableUserCountByUserId` mutation. */
export type DecrementRemainingAddableUserCountByUserIdPayload = {
  __typename?: 'DecrementRemainingAddableUserCountByUserIdPayload';
  _user?: Maybe<User>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge?: Maybe<UsersEdge>;
};


/** The output of our `decrementRemainingAddableUserCountByUserId` mutation. */
export type DecrementRemainingAddableUserCountByUserIdPayloadUserEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** All input for the `deleteCustomShiftById` mutation. */
export type DeleteCustomShiftByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** All input for the `deleteCustomShift` mutation. */
export type DeleteCustomShiftInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `CustomShift` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The output of our delete `CustomShift` mutation. */
export type DeleteCustomShiftPayload = {
  __typename?: 'DeleteCustomShiftPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `CustomShift` that was deleted by this mutation. */
  customShift?: Maybe<CustomShift>;
  /** An edge for our `CustomShift`. May be used by Relay 1. */
  customShiftEdge?: Maybe<CustomShiftsEdge>;
  deletedCustomShiftId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Workplace` that is related to this `CustomShift`. */
  workplaceByWorkplaceId?: Maybe<Workplace>;
};


/** The output of our delete `CustomShift` mutation. */
export type DeleteCustomShiftPayloadCustomShiftEdgeArgs = {
  orderBy?: InputMaybe<Array<CustomShiftsOrderBy>>;
};

/** All input for the `deleteDeviceById` mutation. */
export type DeleteDeviceByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** All input for the `deleteDevice` mutation. */
export type DeleteDeviceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Device` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The output of our delete `Device` mutation. */
export type DeleteDevicePayload = {
  __typename?: 'DeleteDevicePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedDeviceId?: Maybe<Scalars['ID']>;
  /** The `Device` that was deleted by this mutation. */
  device?: Maybe<Device>;
  /** An edge for our `Device`. May be used by Relay 1. */
  deviceEdge?: Maybe<DevicesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Device`. */
  userByUserId?: Maybe<User>;
};


/** The output of our delete `Device` mutation. */
export type DeleteDevicePayloadDeviceEdgeArgs = {
  orderBy?: InputMaybe<Array<DevicesOrderBy>>;
};

/** All input for the `deleteMemoById` mutation. */
export type DeleteMemoByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** All input for the `deleteMemo` mutation. */
export type DeleteMemoInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Memo` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The output of our delete `Memo` mutation. */
export type DeleteMemoPayload = {
  __typename?: 'DeleteMemoPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedMemoId?: Maybe<Scalars['ID']>;
  /** The `Memo` that was deleted by this mutation. */
  memo?: Maybe<Memo>;
  /** An edge for our `Memo`. May be used by Relay 1. */
  memoEdge?: Maybe<MemosEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Workplace` that is related to this `Memo`. */
  workplaceByWorkplaceId?: Maybe<Workplace>;
};


/** The output of our delete `Memo` mutation. */
export type DeleteMemoPayloadMemoEdgeArgs = {
  orderBy?: InputMaybe<Array<MemosOrderBy>>;
};

/** All input for the `deletePgmigrationById` mutation. */
export type DeletePgmigrationByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** All input for the `deletePgmigration` mutation. */
export type DeletePgmigrationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Pgmigration` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The output of our delete `Pgmigration` mutation. */
export type DeletePgmigrationPayload = {
  __typename?: 'DeletePgmigrationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedPgmigrationId?: Maybe<Scalars['ID']>;
  /** The `Pgmigration` that was deleted by this mutation. */
  pgmigration?: Maybe<Pgmigration>;
  /** An edge for our `Pgmigration`. May be used by Relay 1. */
  pgmigrationEdge?: Maybe<PgmigrationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `Pgmigration` mutation. */
export type DeletePgmigrationPayloadPgmigrationEdgeArgs = {
  orderBy?: InputMaybe<Array<PgmigrationsOrderBy>>;
};

/** All input for the `deletePrismaMigrationById` mutation. */
export type DeletePrismaMigrationByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};

/** All input for the `deletePrismaMigration` mutation. */
export type DeletePrismaMigrationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `_PrismaMigration` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The output of our delete `_PrismaMigration` mutation. */
export type DeletePrismaMigrationPayload = {
  __typename?: 'DeletePrismaMigrationPayload';
  /** The `_PrismaMigration` that was deleted by this mutation. */
  _prismaMigration?: Maybe<_PrismaMigration>;
  /** An edge for our `_PrismaMigration`. May be used by Relay 1. */
  _prismaMigrationEdge?: Maybe<_PrismaMigrationsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedPrismaMigrationId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `_PrismaMigration` mutation. */
export type DeletePrismaMigrationPayload_PrismaMigrationEdgeArgs = {
  orderBy?: InputMaybe<Array<_PrismaMigrationsOrderBy>>;
};

/** All input for the `deleteShiftById` mutation. */
export type DeleteShiftByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** All input for the `deleteShift` mutation. */
export type DeleteShiftInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Shift` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The output of our delete `Shift` mutation. */
export type DeleteShiftPayload = {
  __typename?: 'DeleteShiftPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `CustomShift` that is related to this `Shift`. */
  customShiftByCustomShiftId?: Maybe<CustomShift>;
  deletedShiftId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Shift` that was deleted by this mutation. */
  shift?: Maybe<Shift>;
  /** An edge for our `Shift`. May be used by Relay 1. */
  shiftEdge?: Maybe<ShiftsEdge>;
  /** Reads a single `ShiftSetting` that is related to this `Shift`. */
  shiftSettingByShiftSettingId?: Maybe<ShiftSetting>;
  /** Reads a single `Workplace` that is related to this `Shift`. */
  workplaceByWorkplaceId?: Maybe<Workplace>;
  /** Reads a single `WorkplaceUser` that is related to this `Shift`. */
  workplaceUserByWorkplaceUserId?: Maybe<WorkplaceUser>;
};


/** The output of our delete `Shift` mutation. */
export type DeleteShiftPayloadShiftEdgeArgs = {
  orderBy?: InputMaybe<Array<ShiftsOrderBy>>;
};

/** All input for the `deleteShiftSettingById` mutation. */
export type DeleteShiftSettingByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** All input for the `deleteShiftSetting` mutation. */
export type DeleteShiftSettingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ShiftSetting` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The output of our delete `ShiftSetting` mutation. */
export type DeleteShiftSettingPayload = {
  __typename?: 'DeleteShiftSettingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedShiftSettingId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `ShiftSetting` that was deleted by this mutation. */
  shiftSetting?: Maybe<ShiftSetting>;
  /** An edge for our `ShiftSetting`. May be used by Relay 1. */
  shiftSettingEdge?: Maybe<ShiftSettingsEdge>;
  /** Reads a single `Workplace` that is related to this `ShiftSetting`. */
  workplaceByWorkplaceId?: Maybe<Workplace>;
};


/** The output of our delete `ShiftSetting` mutation. */
export type DeleteShiftSettingPayloadShiftSettingEdgeArgs = {
  orderBy?: InputMaybe<Array<ShiftSettingsOrderBy>>;
};

/** All input for the `deleteShiftsByWorkplaceIdAndDate` mutation. */
export type DeleteShiftsByWorkplaceIdAndDateInput = {
  _date?: InputMaybe<Scalars['Date']>;
  _workplaceId?: InputMaybe<Scalars['UUID']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our `deleteShiftsByWorkplaceIdAndDate` mutation. */
export type DeleteShiftsByWorkplaceIdAndDatePayload = {
  __typename?: 'DeleteShiftsByWorkplaceIdAndDatePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `CustomShift` that is related to this `Shift`. */
  customShiftByCustomShiftId?: Maybe<CustomShift>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  shift?: Maybe<Shift>;
  /** An edge for our `Shift`. May be used by Relay 1. */
  shiftEdge?: Maybe<ShiftsEdge>;
  /** Reads a single `ShiftSetting` that is related to this `Shift`. */
  shiftSettingByShiftSettingId?: Maybe<ShiftSetting>;
  /** Reads a single `Workplace` that is related to this `Shift`. */
  workplaceByWorkplaceId?: Maybe<Workplace>;
  /** Reads a single `WorkplaceUser` that is related to this `Shift`. */
  workplaceUserByWorkplaceUserId?: Maybe<WorkplaceUser>;
};


/** The output of our `deleteShiftsByWorkplaceIdAndDate` mutation. */
export type DeleteShiftsByWorkplaceIdAndDatePayloadShiftEdgeArgs = {
  orderBy?: InputMaybe<Array<ShiftsOrderBy>>;
};

/** All input for the `deleteShiftsForWorkplaceUserBetweenDate` mutation. */
export type DeleteShiftsForWorkplaceUserBetweenDateInput = {
  _workplaceUserId?: InputMaybe<Scalars['UUID']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  fromDate?: InputMaybe<Scalars['Date']>;
  toDate?: InputMaybe<Scalars['Date']>;
};

/** The output of our `deleteShiftsForWorkplaceUserBetweenDate` mutation. */
export type DeleteShiftsForWorkplaceUserBetweenDatePayload = {
  __typename?: 'DeleteShiftsForWorkplaceUserBetweenDatePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `CustomShift` that is related to this `Shift`. */
  customShiftByCustomShiftId?: Maybe<CustomShift>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  shift?: Maybe<Shift>;
  /** An edge for our `Shift`. May be used by Relay 1. */
  shiftEdge?: Maybe<ShiftsEdge>;
  /** Reads a single `ShiftSetting` that is related to this `Shift`. */
  shiftSettingByShiftSettingId?: Maybe<ShiftSetting>;
  /** Reads a single `Workplace` that is related to this `Shift`. */
  workplaceByWorkplaceId?: Maybe<Workplace>;
  /** Reads a single `WorkplaceUser` that is related to this `Shift`. */
  workplaceUserByWorkplaceUserId?: Maybe<WorkplaceUser>;
};


/** The output of our `deleteShiftsForWorkplaceUserBetweenDate` mutation. */
export type DeleteShiftsForWorkplaceUserBetweenDatePayloadShiftEdgeArgs = {
  orderBy?: InputMaybe<Array<ShiftsOrderBy>>;
};

/** All input for the `deleteUserById` mutation. */
export type DeleteUserByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** All input for the `deleteUser` mutation. */
export type DeleteUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `User` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The output of our delete `User` mutation. */
export type DeleteUserPayload = {
  __typename?: 'DeleteUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedUserId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `User` that was deleted by this mutation. */
  user?: Maybe<User>;
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge?: Maybe<UsersEdge>;
};


/** The output of our delete `User` mutation. */
export type DeleteUserPayloadUserEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** All input for the `deleteUsersByDeviceIdentifier` mutation. */
export type DeleteUsersByDeviceIdentifierInput = {
  _deviceIdentifier?: InputMaybe<Scalars['String']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our `deleteUsersByDeviceIdentifier` mutation. */
export type DeleteUsersByDeviceIdentifierPayload = {
  __typename?: 'DeleteUsersByDeviceIdentifierPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  user?: Maybe<User>;
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge?: Maybe<UsersEdge>;
};


/** The output of our `deleteUsersByDeviceIdentifier` mutation. */
export type DeleteUsersByDeviceIdentifierPayloadUserEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** All input for the `deleteWorkplaceById` mutation. */
export type DeleteWorkplaceByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** All input for the `deleteWorkplace` mutation. */
export type DeleteWorkplaceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Workplace` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The output of our delete `Workplace` mutation. */
export type DeleteWorkplacePayload = {
  __typename?: 'DeleteWorkplacePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedWorkplaceId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Workplace` that was deleted by this mutation. */
  workplace?: Maybe<Workplace>;
  /** An edge for our `Workplace`. May be used by Relay 1. */
  workplaceEdge?: Maybe<WorkplacesEdge>;
};


/** The output of our delete `Workplace` mutation. */
export type DeleteWorkplacePayloadWorkplaceEdgeArgs = {
  orderBy?: InputMaybe<Array<WorkplacesOrderBy>>;
};

/** All input for the `deleteWorkplaceUserById` mutation. */
export type DeleteWorkplaceUserByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** All input for the `deleteWorkplaceUser` mutation. */
export type DeleteWorkplaceUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `WorkplaceUser` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The output of our delete `WorkplaceUser` mutation. */
export type DeleteWorkplaceUserPayload = {
  __typename?: 'DeleteWorkplaceUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedWorkplaceUserId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `WorkplaceUser`. */
  userByUserId?: Maybe<User>;
  /** Reads a single `Workplace` that is related to this `WorkplaceUser`. */
  workplaceByWorkplaceId?: Maybe<Workplace>;
  /** The `WorkplaceUser` that was deleted by this mutation. */
  workplaceUser?: Maybe<WorkplaceUser>;
  /** An edge for our `WorkplaceUser`. May be used by Relay 1. */
  workplaceUserEdge?: Maybe<WorkplaceUsersEdge>;
};


/** The output of our delete `WorkplaceUser` mutation. */
export type DeleteWorkplaceUserPayloadWorkplaceUserEdgeArgs = {
  orderBy?: InputMaybe<Array<WorkplaceUsersOrderBy>>;
};

export type Device = Node & {
  __typename?: 'Device';
  createdAt: Scalars['Datetime'];
  deviceIdentifier: Scalars['String'];
  deviceName: Scalars['String'];
  id: Scalars['UUID'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  platform: Scalars['String'];
  updatedAt: Scalars['Datetime'];
  /** Reads a single `User` that is related to this `Device`. */
  userByUserId?: Maybe<User>;
  userId: Scalars['UUID'];
};

/** A condition to be used against `Device` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type DeviceCondition = {
  /** Checks for equality with the object’s `deviceIdentifier` field. */
  deviceIdentifier?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
};

/** An input for mutations affecting `Device` */
export type DeviceInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deviceIdentifier: Scalars['String'];
  deviceName: Scalars['String'];
  id?: InputMaybe<Scalars['UUID']>;
  platform: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userId: Scalars['UUID'];
};

/** Represents an update to a `Device`. Fields that are set will be updated. */
export type DevicePatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deviceIdentifier?: InputMaybe<Scalars['String']>;
  deviceName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  platform?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `Device` values. */
export type DevicesConnection = {
  __typename?: 'DevicesConnection';
  /** A list of edges which contains the `Device` and cursor to aid in pagination. */
  edges: Array<DevicesEdge>;
  /** A list of `Device` objects. */
  nodes: Array<Device>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Device` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Device` edge in the connection. */
export type DevicesEdge = {
  __typename?: 'DevicesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Device` at the end of the edge. */
  node: Device;
};

/** Methods to use when ordering `Device`. */
export enum DevicesOrderBy {
  DeviceIdentifierAsc = 'DEVICE_IDENTIFIER_ASC',
  DeviceIdentifierDesc = 'DEVICE_IDENTIFIER_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

export type Memo = Node & {
  __typename?: 'Memo';
  content: Scalars['String'];
  createdAt: Scalars['Datetime'];
  date: Scalars['Date'];
  id: Scalars['UUID'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  updatedAt: Scalars['Datetime'];
  /** Reads a single `Workplace` that is related to this `Memo`. */
  workplaceByWorkplaceId?: Maybe<Workplace>;
  workplaceId: Scalars['UUID'];
};

/** A condition to be used against `Memo` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type MemoCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `workplaceId` field. */
  workplaceId?: InputMaybe<Scalars['UUID']>;
};

/** An input for mutations affecting `Memo` */
export type MemoInput = {
  content: Scalars['String'];
  createdAt?: InputMaybe<Scalars['Datetime']>;
  date: Scalars['Date'];
  id?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  workplaceId: Scalars['UUID'];
};

/** Represents an update to a `Memo`. Fields that are set will be updated. */
export type MemoPatch = {
  content?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  date?: InputMaybe<Scalars['Date']>;
  id?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `Memo` values. */
export type MemosConnection = {
  __typename?: 'MemosConnection';
  /** A list of edges which contains the `Memo` and cursor to aid in pagination. */
  edges: Array<MemosEdge>;
  /** A list of `Memo` objects. */
  nodes: Array<Memo>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Memo` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Memo` edge in the connection. */
export type MemosEdge = {
  __typename?: 'MemosEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Memo` at the end of the edge. */
  node: Memo;
};

/** Methods to use when ordering `Memo`. */
export enum MemosOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  WorkplaceIdAsc = 'WORKPLACE_ID_ASC',
  WorkplaceIdDesc = 'WORKPLACE_ID_DESC'
}

/** The root mutation type which contains root level fields which mutate data. */
export type Mutation = {
  __typename?: 'Mutation';
  addRemainingAddableUserCountByUserId?: Maybe<AddRemainingAddableUserCountByUserIdPayload>;
  /** Creates a single `CustomShift`. */
  createCustomShift?: Maybe<CreateCustomShiftPayload>;
  /** Creates a single `Device`. */
  createDevice?: Maybe<CreateDevicePayload>;
  /** Creates a single `Memo`. */
  createMemo?: Maybe<CreateMemoPayload>;
  /** Creates a single `Pgmigration`. */
  createPgmigration?: Maybe<CreatePgmigrationPayload>;
  /** Creates a single `_PrismaMigration`. */
  createPrismaMigration?: Maybe<CreatePrismaMigrationPayload>;
  /** Creates a single `Shift`. */
  createShift?: Maybe<CreateShiftPayload>;
  /** Creates a single `ShiftSetting`. */
  createShiftSetting?: Maybe<CreateShiftSettingPayload>;
  /** Creates a single `User`. */
  createUser?: Maybe<CreateUserPayload>;
  /** Creates a single `Workplace`. */
  createWorkplace?: Maybe<CreateWorkplacePayload>;
  /** Creates a single `WorkplaceUser`. */
  createWorkplaceUser?: Maybe<CreateWorkplaceUserPayload>;
  decrementRemainingAddableUserCountByUserId?: Maybe<DecrementRemainingAddableUserCountByUserIdPayload>;
  /** Deletes a single `CustomShift` using its globally unique id. */
  deleteCustomShift?: Maybe<DeleteCustomShiftPayload>;
  /** Deletes a single `CustomShift` using a unique key. */
  deleteCustomShiftById?: Maybe<DeleteCustomShiftPayload>;
  /** Deletes a single `Device` using its globally unique id. */
  deleteDevice?: Maybe<DeleteDevicePayload>;
  /** Deletes a single `Device` using a unique key. */
  deleteDeviceById?: Maybe<DeleteDevicePayload>;
  /** Deletes a single `Memo` using its globally unique id. */
  deleteMemo?: Maybe<DeleteMemoPayload>;
  /** Deletes a single `Memo` using a unique key. */
  deleteMemoById?: Maybe<DeleteMemoPayload>;
  /** Deletes a single `Pgmigration` using its globally unique id. */
  deletePgmigration?: Maybe<DeletePgmigrationPayload>;
  /** Deletes a single `Pgmigration` using a unique key. */
  deletePgmigrationById?: Maybe<DeletePgmigrationPayload>;
  /** Deletes a single `_PrismaMigration` using its globally unique id. */
  deletePrismaMigration?: Maybe<DeletePrismaMigrationPayload>;
  /** Deletes a single `_PrismaMigration` using a unique key. */
  deletePrismaMigrationById?: Maybe<DeletePrismaMigrationPayload>;
  /** Deletes a single `Shift` using its globally unique id. */
  deleteShift?: Maybe<DeleteShiftPayload>;
  /** Deletes a single `Shift` using a unique key. */
  deleteShiftById?: Maybe<DeleteShiftPayload>;
  /** Deletes a single `ShiftSetting` using its globally unique id. */
  deleteShiftSetting?: Maybe<DeleteShiftSettingPayload>;
  /** Deletes a single `ShiftSetting` using a unique key. */
  deleteShiftSettingById?: Maybe<DeleteShiftSettingPayload>;
  deleteShiftsByWorkplaceIdAndDate?: Maybe<DeleteShiftsByWorkplaceIdAndDatePayload>;
  deleteShiftsForWorkplaceUserBetweenDate?: Maybe<DeleteShiftsForWorkplaceUserBetweenDatePayload>;
  /** Deletes a single `User` using its globally unique id. */
  deleteUser?: Maybe<DeleteUserPayload>;
  /** Deletes a single `User` using a unique key. */
  deleteUserById?: Maybe<DeleteUserPayload>;
  deleteUsersByDeviceIdentifier?: Maybe<DeleteUsersByDeviceIdentifierPayload>;
  /** Deletes a single `Workplace` using its globally unique id. */
  deleteWorkplace?: Maybe<DeleteWorkplacePayload>;
  /** Deletes a single `Workplace` using a unique key. */
  deleteWorkplaceById?: Maybe<DeleteWorkplacePayload>;
  /** Deletes a single `WorkplaceUser` using its globally unique id. */
  deleteWorkplaceUser?: Maybe<DeleteWorkplaceUserPayload>;
  /** Deletes a single `WorkplaceUser` using a unique key. */
  deleteWorkplaceUserById?: Maybe<DeleteWorkplaceUserPayload>;
  /** Creates one or many `CustomShift`. */
  mnCreateCustomShift?: Maybe<MnCreateCustomShiftPayload>;
  /** Creates one or many `Device`. */
  mnCreateDevice?: Maybe<MnCreateDevicePayload>;
  /** Creates one or many `Memo`. */
  mnCreateMemo?: Maybe<MnCreateMemoPayload>;
  /** Creates one or many `Shift`. */
  mnCreateShift?: Maybe<MnCreateShiftPayload>;
  /** Creates one or many `ShiftSetting`. */
  mnCreateShiftSetting?: Maybe<MnCreateShiftSettingPayload>;
  /** Creates one or many `User`. */
  mnCreateUser?: Maybe<MnCreateUserPayload>;
  /** Creates one or many `Workplace`. */
  mnCreateWorkplace?: Maybe<MnCreateWorkplacePayload>;
  /** Creates one or many `WorkplaceUser`. */
  mnCreateWorkplaceUser?: Maybe<MnCreateWorkplaceUserPayload>;
  /** Deletes one or many `CustomShift` a unique key via a patch. */
  mnDeleteCustomShiftById?: Maybe<MnDeleteCustomShiftPayload>;
  /** Deletes one or many `Device` a unique key via a patch. */
  mnDeleteDeviceById?: Maybe<MnDeleteDevicePayload>;
  /** Deletes one or many `Memo` a unique key via a patch. */
  mnDeleteMemoById?: Maybe<MnDeleteMemoPayload>;
  /** Deletes one or many `Shift` a unique key via a patch. */
  mnDeleteShiftById?: Maybe<MnDeleteShiftPayload>;
  /** Deletes one or many `ShiftSetting` a unique key via a patch. */
  mnDeleteShiftSettingById?: Maybe<MnDeleteShiftSettingPayload>;
  /** Deletes one or many `User` a unique key via a patch. */
  mnDeleteUserById?: Maybe<MnDeleteUserPayload>;
  /** Deletes one or many `Workplace` a unique key via a patch. */
  mnDeleteWorkplaceById?: Maybe<MnDeleteWorkplacePayload>;
  /** Deletes one or many `WorkplaceUser` a unique key via a patch. */
  mnDeleteWorkplaceUserById?: Maybe<MnDeleteWorkplaceUserPayload>;
  /** Updates one or many `CustomShift` using a unique key and a patch. */
  mnUpdateCustomShiftById?: Maybe<MnUpdateCustomShiftPayload>;
  /** Updates one or many `Device` using a unique key and a patch. */
  mnUpdateDeviceById?: Maybe<MnUpdateDevicePayload>;
  /** Updates one or many `Memo` using a unique key and a patch. */
  mnUpdateMemoById?: Maybe<MnUpdateMemoPayload>;
  /** Updates one or many `Shift` using a unique key and a patch. */
  mnUpdateShiftById?: Maybe<MnUpdateShiftPayload>;
  /** Updates one or many `ShiftSetting` using a unique key and a patch. */
  mnUpdateShiftSettingById?: Maybe<MnUpdateShiftSettingPayload>;
  /** Updates one or many `User` using a unique key and a patch. */
  mnUpdateUserById?: Maybe<MnUpdateUserPayload>;
  /** Updates one or many `Workplace` using a unique key and a patch. */
  mnUpdateWorkplaceById?: Maybe<MnUpdateWorkplacePayload>;
  /** Updates one or many `WorkplaceUser` using a unique key and a patch. */
  mnUpdateWorkplaceUserById?: Maybe<MnUpdateWorkplaceUserPayload>;
  selectMemosByWorkplaceIdAndDate?: Maybe<SelectMemosByWorkplaceIdAndDatePayload>;
  selectMemosByWorkplaceIdAndYearAndMonthAndStartDay?: Maybe<SelectMemosByWorkplaceIdAndYearAndMonthAndStartDayPayload>;
  selectShiftsByWorkplaceIdAndDate?: Maybe<SelectShiftsByWorkplaceIdAndDatePayload>;
  selectShiftsByWorkplaceIdAndYearAndMonthAndStartDay?: Maybe<SelectShiftsByWorkplaceIdAndYearAndMonthAndStartDayPayload>;
  /** Updates a single `CustomShift` using its globally unique id and a patch. */
  updateCustomShift?: Maybe<UpdateCustomShiftPayload>;
  /** Updates a single `CustomShift` using a unique key and a patch. */
  updateCustomShiftById?: Maybe<UpdateCustomShiftPayload>;
  /** Updates a single `Device` using its globally unique id and a patch. */
  updateDevice?: Maybe<UpdateDevicePayload>;
  /** Updates a single `Device` using a unique key and a patch. */
  updateDeviceById?: Maybe<UpdateDevicePayload>;
  /** Updates a single `Memo` using its globally unique id and a patch. */
  updateMemo?: Maybe<UpdateMemoPayload>;
  /** Updates a single `Memo` using a unique key and a patch. */
  updateMemoById?: Maybe<UpdateMemoPayload>;
  /** Updates a single `Pgmigration` using its globally unique id and a patch. */
  updatePgmigration?: Maybe<UpdatePgmigrationPayload>;
  /** Updates a single `Pgmigration` using a unique key and a patch. */
  updatePgmigrationById?: Maybe<UpdatePgmigrationPayload>;
  /** Updates a single `_PrismaMigration` using its globally unique id and a patch. */
  updatePrismaMigration?: Maybe<UpdatePrismaMigrationPayload>;
  /** Updates a single `_PrismaMigration` using a unique key and a patch. */
  updatePrismaMigrationById?: Maybe<UpdatePrismaMigrationPayload>;
  /** Updates a single `Shift` using its globally unique id and a patch. */
  updateShift?: Maybe<UpdateShiftPayload>;
  /** Updates a single `Shift` using a unique key and a patch. */
  updateShiftById?: Maybe<UpdateShiftPayload>;
  /** Updates a single `ShiftSetting` using its globally unique id and a patch. */
  updateShiftSetting?: Maybe<UpdateShiftSettingPayload>;
  /** Updates a single `ShiftSetting` using a unique key and a patch. */
  updateShiftSettingById?: Maybe<UpdateShiftSettingPayload>;
  /** Updates a single `User` using its globally unique id and a patch. */
  updateUser?: Maybe<UpdateUserPayload>;
  /** Updates a single `User` using a unique key and a patch. */
  updateUserById?: Maybe<UpdateUserPayload>;
  /** Updates a single `Workplace` using its globally unique id and a patch. */
  updateWorkplace?: Maybe<UpdateWorkplacePayload>;
  /** Updates a single `Workplace` using a unique key and a patch. */
  updateWorkplaceById?: Maybe<UpdateWorkplacePayload>;
  /** Updates a single `WorkplaceUser` using its globally unique id and a patch. */
  updateWorkplaceUser?: Maybe<UpdateWorkplaceUserPayload>;
  /** Updates a single `WorkplaceUser` using a unique key and a patch. */
  updateWorkplaceUserById?: Maybe<UpdateWorkplaceUserPayload>;
  /** Upserts a single `CustomShift`. */
  upsertCustomShift?: Maybe<UpsertCustomShiftPayload>;
  /** Upserts a single `Device`. */
  upsertDevice?: Maybe<UpsertDevicePayload>;
  /** Upserts a single `Memo`. */
  upsertMemo?: Maybe<UpsertMemoPayload>;
  /** Upserts a single `Pgmigration`. */
  upsertPgmigration?: Maybe<UpsertPgmigrationPayload>;
  /** Upserts a single `Shift`. */
  upsertShift?: Maybe<UpsertShiftPayload>;
  /** Upserts a single `ShiftSetting`. */
  upsertShiftSetting?: Maybe<UpsertShiftSettingPayload>;
  /** Upserts a single `User`. */
  upsertUser?: Maybe<UpsertUserPayload>;
  /** Upserts a single `Workplace`. */
  upsertWorkplace?: Maybe<UpsertWorkplacePayload>;
  /** Upserts a single `WorkplaceUser`. */
  upsertWorkplaceUser?: Maybe<UpsertWorkplaceUserPayload>;
  /** Upserts a single `_PrismaMigration`. */
  upsert_PrismaMigration?: Maybe<Upsert_PrismaMigrationPayload>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAddRemainingAddableUserCountByUserIdArgs = {
  input: AddRemainingAddableUserCountByUserIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCustomShiftArgs = {
  input: CreateCustomShiftInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateDeviceArgs = {
  input: CreateDeviceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateMemoArgs = {
  input: CreateMemoInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePgmigrationArgs = {
  input: CreatePgmigrationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePrismaMigrationArgs = {
  input: CreatePrismaMigrationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateShiftArgs = {
  input: CreateShiftInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateShiftSettingArgs = {
  input: CreateShiftSettingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateWorkplaceArgs = {
  input: CreateWorkplaceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateWorkplaceUserArgs = {
  input: CreateWorkplaceUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDecrementRemainingAddableUserCountByUserIdArgs = {
  input: DecrementRemainingAddableUserCountByUserIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCustomShiftArgs = {
  input: DeleteCustomShiftInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCustomShiftByIdArgs = {
  input: DeleteCustomShiftByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDeviceArgs = {
  input: DeleteDeviceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDeviceByIdArgs = {
  input: DeleteDeviceByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMemoArgs = {
  input: DeleteMemoInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMemoByIdArgs = {
  input: DeleteMemoByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePgmigrationArgs = {
  input: DeletePgmigrationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePgmigrationByIdArgs = {
  input: DeletePgmigrationByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePrismaMigrationArgs = {
  input: DeletePrismaMigrationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePrismaMigrationByIdArgs = {
  input: DeletePrismaMigrationByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteShiftArgs = {
  input: DeleteShiftInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteShiftByIdArgs = {
  input: DeleteShiftByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteShiftSettingArgs = {
  input: DeleteShiftSettingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteShiftSettingByIdArgs = {
  input: DeleteShiftSettingByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteShiftsByWorkplaceIdAndDateArgs = {
  input: DeleteShiftsByWorkplaceIdAndDateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteShiftsForWorkplaceUserBetweenDateArgs = {
  input: DeleteShiftsForWorkplaceUserBetweenDateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserArgs = {
  input: DeleteUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserByIdArgs = {
  input: DeleteUserByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUsersByDeviceIdentifierArgs = {
  input: DeleteUsersByDeviceIdentifierInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteWorkplaceArgs = {
  input: DeleteWorkplaceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteWorkplaceByIdArgs = {
  input: DeleteWorkplaceByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteWorkplaceUserArgs = {
  input: DeleteWorkplaceUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteWorkplaceUserByIdArgs = {
  input: DeleteWorkplaceUserByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationMnCreateCustomShiftArgs = {
  input: MnCreateCustomShiftInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationMnCreateDeviceArgs = {
  input: MnCreateDeviceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationMnCreateMemoArgs = {
  input: MnCreateMemoInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationMnCreateShiftArgs = {
  input: MnCreateShiftInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationMnCreateShiftSettingArgs = {
  input: MnCreateShiftSettingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationMnCreateUserArgs = {
  input: MnCreateUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationMnCreateWorkplaceArgs = {
  input: MnCreateWorkplaceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationMnCreateWorkplaceUserArgs = {
  input: MnCreateWorkplaceUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationMnDeleteCustomShiftByIdArgs = {
  input: MnDeleteCustomShiftByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationMnDeleteDeviceByIdArgs = {
  input: MnDeleteDeviceByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationMnDeleteMemoByIdArgs = {
  input: MnDeleteMemoByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationMnDeleteShiftByIdArgs = {
  input: MnDeleteShiftByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationMnDeleteShiftSettingByIdArgs = {
  input: MnDeleteShiftSettingByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationMnDeleteUserByIdArgs = {
  input: MnDeleteUserByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationMnDeleteWorkplaceByIdArgs = {
  input: MnDeleteWorkplaceByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationMnDeleteWorkplaceUserByIdArgs = {
  input: MnDeleteWorkplaceUserByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationMnUpdateCustomShiftByIdArgs = {
  input: MnUpdateCustomShiftByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationMnUpdateDeviceByIdArgs = {
  input: MnUpdateDeviceByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationMnUpdateMemoByIdArgs = {
  input: MnUpdateMemoByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationMnUpdateShiftByIdArgs = {
  input: MnUpdateShiftByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationMnUpdateShiftSettingByIdArgs = {
  input: MnUpdateShiftSettingByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationMnUpdateUserByIdArgs = {
  input: MnUpdateUserByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationMnUpdateWorkplaceByIdArgs = {
  input: MnUpdateWorkplaceByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationMnUpdateWorkplaceUserByIdArgs = {
  input: MnUpdateWorkplaceUserByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSelectMemosByWorkplaceIdAndDateArgs = {
  input: SelectMemosByWorkplaceIdAndDateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSelectMemosByWorkplaceIdAndYearAndMonthAndStartDayArgs = {
  input: SelectMemosByWorkplaceIdAndYearAndMonthAndStartDayInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSelectShiftsByWorkplaceIdAndDateArgs = {
  input: SelectShiftsByWorkplaceIdAndDateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSelectShiftsByWorkplaceIdAndYearAndMonthAndStartDayArgs = {
  input: SelectShiftsByWorkplaceIdAndYearAndMonthAndStartDayInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCustomShiftArgs = {
  input: UpdateCustomShiftInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCustomShiftByIdArgs = {
  input: UpdateCustomShiftByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDeviceArgs = {
  input: UpdateDeviceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDeviceByIdArgs = {
  input: UpdateDeviceByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMemoArgs = {
  input: UpdateMemoInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMemoByIdArgs = {
  input: UpdateMemoByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePgmigrationArgs = {
  input: UpdatePgmigrationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePgmigrationByIdArgs = {
  input: UpdatePgmigrationByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePrismaMigrationArgs = {
  input: UpdatePrismaMigrationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePrismaMigrationByIdArgs = {
  input: UpdatePrismaMigrationByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateShiftArgs = {
  input: UpdateShiftInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateShiftByIdArgs = {
  input: UpdateShiftByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateShiftSettingArgs = {
  input: UpdateShiftSettingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateShiftSettingByIdArgs = {
  input: UpdateShiftSettingByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserByIdArgs = {
  input: UpdateUserByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateWorkplaceArgs = {
  input: UpdateWorkplaceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateWorkplaceByIdArgs = {
  input: UpdateWorkplaceByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateWorkplaceUserArgs = {
  input: UpdateWorkplaceUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateWorkplaceUserByIdArgs = {
  input: UpdateWorkplaceUserByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertCustomShiftArgs = {
  input: UpsertCustomShiftInput;
  where?: InputMaybe<UpsertCustomShiftWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertDeviceArgs = {
  input: UpsertDeviceInput;
  where?: InputMaybe<UpsertDeviceWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertMemoArgs = {
  input: UpsertMemoInput;
  where?: InputMaybe<UpsertMemoWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertPgmigrationArgs = {
  input: UpsertPgmigrationInput;
  where?: InputMaybe<UpsertPgmigrationWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertShiftArgs = {
  input: UpsertShiftInput;
  where?: InputMaybe<UpsertShiftWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertShiftSettingArgs = {
  input: UpsertShiftSettingInput;
  where?: InputMaybe<UpsertShiftSettingWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertUserArgs = {
  input: UpsertUserInput;
  where?: InputMaybe<UpsertUserWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertWorkplaceArgs = {
  input: UpsertWorkplaceInput;
  where?: InputMaybe<UpsertWorkplaceWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertWorkplaceUserArgs = {
  input: UpsertWorkplaceUserInput;
  where?: InputMaybe<UpsertWorkplaceUserWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsert_PrismaMigrationArgs = {
  input: Upsert_PrismaMigrationInput;
  where?: InputMaybe<Upsert_PrismaMigrationWhere>;
};

/** An object with a globally unique `ID`. */
export type Node = {
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['Cursor']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['Cursor']>;
};

export type Pgmigration = Node & {
  __typename?: 'Pgmigration';
  id: Scalars['Int'];
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  runOn: Scalars['Datetime'];
};

/**
 * A condition to be used against `Pgmigration` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type PgmigrationCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
};

/** An input for mutations affecting `Pgmigration` */
export type PgmigrationInput = {
  id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  runOn: Scalars['Datetime'];
};

/** Represents an update to a `Pgmigration`. Fields that are set will be updated. */
export type PgmigrationPatch = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  runOn?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `Pgmigration` values. */
export type PgmigrationsConnection = {
  __typename?: 'PgmigrationsConnection';
  /** A list of edges which contains the `Pgmigration` and cursor to aid in pagination. */
  edges: Array<PgmigrationsEdge>;
  /** A list of `Pgmigration` objects. */
  nodes: Array<Pgmigration>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Pgmigration` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Pgmigration` edge in the connection. */
export type PgmigrationsEdge = {
  __typename?: 'PgmigrationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Pgmigration` at the end of the edge. */
  node: Pgmigration;
};

/** Methods to use when ordering `Pgmigration`. */
export enum PgmigrationsOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** The root query type which gives access points into the data universe. */
export type Query = Node & {
  __typename?: 'Query';
  /** Reads a single `_PrismaMigration` using its globally unique `ID`. */
  _prismaMigration?: Maybe<_PrismaMigration>;
  _prismaMigrationById?: Maybe<_PrismaMigration>;
  /** Reads and enables pagination through a set of `CustomShift`. */
  allCustomShifts?: Maybe<CustomShiftsConnection>;
  /** Reads and enables pagination through a set of `Device`. */
  allDevices?: Maybe<DevicesConnection>;
  /** Reads and enables pagination through a set of `Memo`. */
  allMemos?: Maybe<MemosConnection>;
  /** Reads and enables pagination through a set of `Pgmigration`. */
  allPgmigrations?: Maybe<PgmigrationsConnection>;
  /** Reads and enables pagination through a set of `_PrismaMigration`. */
  allPrismaMigrations?: Maybe<_PrismaMigrationsConnection>;
  /** Reads and enables pagination through a set of `ShiftSetting`. */
  allShiftSettings?: Maybe<ShiftSettingsConnection>;
  /** Reads and enables pagination through a set of `Shift`. */
  allShifts?: Maybe<ShiftsConnection>;
  /** Reads and enables pagination through a set of `User`. */
  allUsers?: Maybe<UsersConnection>;
  /** Reads and enables pagination through a set of `WorkplaceUser`. */
  allWorkplaceUsers?: Maybe<WorkplaceUsersConnection>;
  /** Reads and enables pagination through a set of `Workplace`. */
  allWorkplaces?: Maybe<WorkplacesConnection>;
  /** Reads a single `CustomShift` using its globally unique `ID`. */
  customShift?: Maybe<CustomShift>;
  customShiftById?: Maybe<CustomShift>;
  /** Reads a single `Device` using its globally unique `ID`. */
  device?: Maybe<Device>;
  deviceById?: Maybe<Device>;
  /** Reads a single `Memo` using its globally unique `ID`. */
  memo?: Maybe<Memo>;
  memoById?: Maybe<Memo>;
  /** Fetches an object given its globally unique `ID`. */
  node?: Maybe<Node>;
  /** The root query type must be a `Node` to work well with Relay 1 mutations. This just resolves to `query`. */
  nodeId: Scalars['ID'];
  /** Reads a single `Pgmigration` using its globally unique `ID`. */
  pgmigration?: Maybe<Pgmigration>;
  pgmigrationById?: Maybe<Pgmigration>;
  /**
   * Exposes the root query type nested one level down. This is helpful for Relay 1
   * which can only query top level fields if they are in a particular form.
   */
  query: Query;
  /** Reads a single `Shift` using its globally unique `ID`. */
  shift?: Maybe<Shift>;
  shiftById?: Maybe<Shift>;
  /** Reads a single `ShiftSetting` using its globally unique `ID`. */
  shiftSetting?: Maybe<ShiftSetting>;
  shiftSettingById?: Maybe<ShiftSetting>;
  /** Reads a single `User` using its globally unique `ID`. */
  user?: Maybe<User>;
  userById?: Maybe<User>;
  /** Reads a single `Workplace` using its globally unique `ID`. */
  workplace?: Maybe<Workplace>;
  workplaceById?: Maybe<Workplace>;
  /** Reads a single `WorkplaceUser` using its globally unique `ID`. */
  workplaceUser?: Maybe<WorkplaceUser>;
  workplaceUserById?: Maybe<WorkplaceUser>;
};


/** The root query type which gives access points into the data universe. */
export type Query_PrismaMigrationArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type Query_PrismaMigrationByIdArgs = {
  id: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAllCustomShiftsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CustomShiftCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CustomShiftsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllDevicesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DeviceCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DevicesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllMemosArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MemoCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MemosOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPgmigrationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PgmigrationCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PgmigrationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPrismaMigrationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<_PrismaMigrationCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<_PrismaMigrationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllShiftSettingsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ShiftSettingCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ShiftSettingsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllShiftsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ShiftCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ShiftsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllWorkplaceUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<WorkplaceUserCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<WorkplaceUsersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllWorkplacesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<WorkplaceCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<WorkplacesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCustomShiftArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCustomShiftByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDeviceArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDeviceByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMemoArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMemoByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryNodeArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPgmigrationArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPgmigrationByIdArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryShiftArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryShiftByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryShiftSettingArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryShiftSettingByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryWorkplaceArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryWorkplaceByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryWorkplaceUserArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryWorkplaceUserByIdArgs = {
  id: Scalars['UUID'];
};

/** All input for the `selectMemosByWorkplaceIdAndDate` mutation. */
export type SelectMemosByWorkplaceIdAndDateInput = {
  _date?: InputMaybe<Scalars['Date']>;
  _workplaceId?: InputMaybe<Scalars['UUID']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our `selectMemosByWorkplaceIdAndDate` mutation. */
export type SelectMemosByWorkplaceIdAndDatePayload = {
  __typename?: 'SelectMemosByWorkplaceIdAndDatePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  memos?: Maybe<Array<Memo>>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `selectMemosByWorkplaceIdAndYearAndMonthAndStartDay` mutation. */
export type SelectMemosByWorkplaceIdAndYearAndMonthAndStartDayInput = {
  _month?: InputMaybe<Scalars['Int']>;
  _startDay?: InputMaybe<Scalars['Int']>;
  _workplaceId?: InputMaybe<Scalars['UUID']>;
  _year?: InputMaybe<Scalars['Int']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our `selectMemosByWorkplaceIdAndYearAndMonthAndStartDay` mutation. */
export type SelectMemosByWorkplaceIdAndYearAndMonthAndStartDayPayload = {
  __typename?: 'SelectMemosByWorkplaceIdAndYearAndMonthAndStartDayPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  memos?: Maybe<Array<Memo>>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `selectShiftsByWorkplaceIdAndDate` mutation. */
export type SelectShiftsByWorkplaceIdAndDateInput = {
  _date?: InputMaybe<Scalars['Date']>;
  _workplaceId?: InputMaybe<Scalars['UUID']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our `selectShiftsByWorkplaceIdAndDate` mutation. */
export type SelectShiftsByWorkplaceIdAndDatePayload = {
  __typename?: 'SelectShiftsByWorkplaceIdAndDatePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  shifts?: Maybe<Array<Shift>>;
};

/** All input for the `selectShiftsByWorkplaceIdAndYearAndMonthAndStartDay` mutation. */
export type SelectShiftsByWorkplaceIdAndYearAndMonthAndStartDayInput = {
  _month?: InputMaybe<Scalars['Int']>;
  _startDay?: InputMaybe<Scalars['Int']>;
  _workplaceId?: InputMaybe<Scalars['UUID']>;
  _year?: InputMaybe<Scalars['Int']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our `selectShiftsByWorkplaceIdAndYearAndMonthAndStartDay` mutation. */
export type SelectShiftsByWorkplaceIdAndYearAndMonthAndStartDayPayload = {
  __typename?: 'SelectShiftsByWorkplaceIdAndYearAndMonthAndStartDayPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  shifts?: Maybe<Array<Shift>>;
};

export type Shift = Node & {
  __typename?: 'Shift';
  createdAt: Scalars['Datetime'];
  /** Reads a single `CustomShift` that is related to this `Shift`. */
  customShiftByCustomShiftId?: Maybe<CustomShift>;
  customShiftId?: Maybe<Scalars['UUID']>;
  date: Scalars['Date'];
  id: Scalars['UUID'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `ShiftSetting` that is related to this `Shift`. */
  shiftSettingByShiftSettingId?: Maybe<ShiftSetting>;
  shiftSettingId?: Maybe<Scalars['UUID']>;
  updatedAt: Scalars['Datetime'];
  /** Reads a single `Workplace` that is related to this `Shift`. */
  workplaceByWorkplaceId?: Maybe<Workplace>;
  workplaceId: Scalars['UUID'];
  /** Reads a single `WorkplaceUser` that is related to this `Shift`. */
  workplaceUserByWorkplaceUserId?: Maybe<WorkplaceUser>;
  workplaceUserId: Scalars['UUID'];
};

/** A condition to be used against `Shift` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type ShiftCondition = {
  /** Checks for equality with the object’s `customShiftId` field. */
  customShiftId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `date` field. */
  date?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `shiftSettingId` field. */
  shiftSettingId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `workplaceId` field. */
  workplaceId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `workplaceUserId` field. */
  workplaceUserId?: InputMaybe<Scalars['UUID']>;
};

/** An input for mutations affecting `Shift` */
export type ShiftInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customShiftId?: InputMaybe<Scalars['UUID']>;
  date: Scalars['Date'];
  id?: InputMaybe<Scalars['UUID']>;
  shiftSettingId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  workplaceId: Scalars['UUID'];
  workplaceUserId: Scalars['UUID'];
};

/** Represents an update to a `Shift`. Fields that are set will be updated. */
export type ShiftPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customShiftId?: InputMaybe<Scalars['UUID']>;
  date?: InputMaybe<Scalars['Date']>;
  id?: InputMaybe<Scalars['UUID']>;
  shiftSettingId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
  workplaceUserId?: InputMaybe<Scalars['UUID']>;
};

export type ShiftSetting = Node & {
  __typename?: 'ShiftSetting';
  createdAt: Scalars['Datetime'];
  hexColor: Scalars['String'];
  id: Scalars['UUID'];
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  order: Scalars['Int'];
  /** Reads and enables pagination through a set of `Shift`. */
  shiftsByShiftSettingId: ShiftsConnection;
  updatedAt: Scalars['Datetime'];
  /** Reads a single `Workplace` that is related to this `ShiftSetting`. */
  workplaceByWorkplaceId?: Maybe<Workplace>;
  workplaceId: Scalars['UUID'];
};


export type ShiftSettingShiftsByShiftSettingIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ShiftCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ShiftsOrderBy>>;
};

/**
 * A condition to be used against `ShiftSetting` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ShiftSettingCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `workplaceId` field. */
  workplaceId?: InputMaybe<Scalars['UUID']>;
};

/** An input for mutations affecting `ShiftSetting` */
export type ShiftSettingInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  hexColor: Scalars['String'];
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  order: Scalars['Int'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  workplaceId: Scalars['UUID'];
};

/** Represents an update to a `ShiftSetting`. Fields that are set will be updated. */
export type ShiftSettingPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  hexColor?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `ShiftSetting` values. */
export type ShiftSettingsConnection = {
  __typename?: 'ShiftSettingsConnection';
  /** A list of edges which contains the `ShiftSetting` and cursor to aid in pagination. */
  edges: Array<ShiftSettingsEdge>;
  /** A list of `ShiftSetting` objects. */
  nodes: Array<ShiftSetting>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ShiftSetting` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ShiftSetting` edge in the connection. */
export type ShiftSettingsEdge = {
  __typename?: 'ShiftSettingsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ShiftSetting` at the end of the edge. */
  node: ShiftSetting;
};

/** Methods to use when ordering `ShiftSetting`. */
export enum ShiftSettingsOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  WorkplaceIdAsc = 'WORKPLACE_ID_ASC',
  WorkplaceIdDesc = 'WORKPLACE_ID_DESC'
}

/** A connection to a list of `Shift` values. */
export type ShiftsConnection = {
  __typename?: 'ShiftsConnection';
  /** A list of edges which contains the `Shift` and cursor to aid in pagination. */
  edges: Array<ShiftsEdge>;
  /** A list of `Shift` objects. */
  nodes: Array<Shift>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Shift` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Shift` edge in the connection. */
export type ShiftsEdge = {
  __typename?: 'ShiftsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Shift` at the end of the edge. */
  node: Shift;
};

/** Methods to use when ordering `Shift`. */
export enum ShiftsOrderBy {
  CustomShiftIdAsc = 'CUSTOM_SHIFT_ID_ASC',
  CustomShiftIdDesc = 'CUSTOM_SHIFT_ID_DESC',
  DateAsc = 'DATE_ASC',
  DateDesc = 'DATE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ShiftSettingIdAsc = 'SHIFT_SETTING_ID_ASC',
  ShiftSettingIdDesc = 'SHIFT_SETTING_ID_DESC',
  WorkplaceIdAsc = 'WORKPLACE_ID_ASC',
  WorkplaceIdDesc = 'WORKPLACE_ID_DESC',
  WorkplaceUserIdAsc = 'WORKPLACE_USER_ID_ASC',
  WorkplaceUserIdDesc = 'WORKPLACE_USER_ID_DESC'
}

/** All input for the `updateCustomShiftById` mutation. */
export type UpdateCustomShiftByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `CustomShift` being updated. */
  customShiftPatch: CustomShiftPatch;
  id: Scalars['UUID'];
};

/** All input for the `updateCustomShift` mutation. */
export type UpdateCustomShiftInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `CustomShift` being updated. */
  customShiftPatch: CustomShiftPatch;
  /** The globally unique `ID` which will identify a single `CustomShift` to be updated. */
  nodeId: Scalars['ID'];
};

/** The output of our update `CustomShift` mutation. */
export type UpdateCustomShiftPayload = {
  __typename?: 'UpdateCustomShiftPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `CustomShift` that was updated by this mutation. */
  customShift?: Maybe<CustomShift>;
  /** An edge for our `CustomShift`. May be used by Relay 1. */
  customShiftEdge?: Maybe<CustomShiftsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Workplace` that is related to this `CustomShift`. */
  workplaceByWorkplaceId?: Maybe<Workplace>;
};


/** The output of our update `CustomShift` mutation. */
export type UpdateCustomShiftPayloadCustomShiftEdgeArgs = {
  orderBy?: InputMaybe<Array<CustomShiftsOrderBy>>;
};

/** All input for the `updateDeviceById` mutation. */
export type UpdateDeviceByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Device` being updated. */
  devicePatch: DevicePatch;
  id: Scalars['UUID'];
};

/** All input for the `updateDevice` mutation. */
export type UpdateDeviceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Device` being updated. */
  devicePatch: DevicePatch;
  /** The globally unique `ID` which will identify a single `Device` to be updated. */
  nodeId: Scalars['ID'];
};

/** The output of our update `Device` mutation. */
export type UpdateDevicePayload = {
  __typename?: 'UpdateDevicePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Device` that was updated by this mutation. */
  device?: Maybe<Device>;
  /** An edge for our `Device`. May be used by Relay 1. */
  deviceEdge?: Maybe<DevicesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Device`. */
  userByUserId?: Maybe<User>;
};


/** The output of our update `Device` mutation. */
export type UpdateDevicePayloadDeviceEdgeArgs = {
  orderBy?: InputMaybe<Array<DevicesOrderBy>>;
};

/** All input for the `updateMemoById` mutation. */
export type UpdateMemoByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Memo` being updated. */
  memoPatch: MemoPatch;
};

/** All input for the `updateMemo` mutation. */
export type UpdateMemoInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Memo` being updated. */
  memoPatch: MemoPatch;
  /** The globally unique `ID` which will identify a single `Memo` to be updated. */
  nodeId: Scalars['ID'];
};

/** The output of our update `Memo` mutation. */
export type UpdateMemoPayload = {
  __typename?: 'UpdateMemoPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Memo` that was updated by this mutation. */
  memo?: Maybe<Memo>;
  /** An edge for our `Memo`. May be used by Relay 1. */
  memoEdge?: Maybe<MemosEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Workplace` that is related to this `Memo`. */
  workplaceByWorkplaceId?: Maybe<Workplace>;
};


/** The output of our update `Memo` mutation. */
export type UpdateMemoPayloadMemoEdgeArgs = {
  orderBy?: InputMaybe<Array<MemosOrderBy>>;
};

/** All input for the `updatePgmigrationById` mutation. */
export type UpdatePgmigrationByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `Pgmigration` being updated. */
  pgmigrationPatch: PgmigrationPatch;
};

/** All input for the `updatePgmigration` mutation. */
export type UpdatePgmigrationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Pgmigration` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Pgmigration` being updated. */
  pgmigrationPatch: PgmigrationPatch;
};

/** The output of our update `Pgmigration` mutation. */
export type UpdatePgmigrationPayload = {
  __typename?: 'UpdatePgmigrationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Pgmigration` that was updated by this mutation. */
  pgmigration?: Maybe<Pgmigration>;
  /** An edge for our `Pgmigration`. May be used by Relay 1. */
  pgmigrationEdge?: Maybe<PgmigrationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `Pgmigration` mutation. */
export type UpdatePgmigrationPayloadPgmigrationEdgeArgs = {
  orderBy?: InputMaybe<Array<PgmigrationsOrderBy>>;
};

/** All input for the `updatePrismaMigrationById` mutation. */
export type UpdatePrismaMigrationByIdInput = {
  /** An object where the defined keys will be set on the `_PrismaMigration` being updated. */
  _prismaMigrationPatch: _PrismaMigrationPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};

/** All input for the `updatePrismaMigration` mutation. */
export type UpdatePrismaMigrationInput = {
  /** An object where the defined keys will be set on the `_PrismaMigration` being updated. */
  _prismaMigrationPatch: _PrismaMigrationPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `_PrismaMigration` to be updated. */
  nodeId: Scalars['ID'];
};

/** The output of our update `_PrismaMigration` mutation. */
export type UpdatePrismaMigrationPayload = {
  __typename?: 'UpdatePrismaMigrationPayload';
  /** The `_PrismaMigration` that was updated by this mutation. */
  _prismaMigration?: Maybe<_PrismaMigration>;
  /** An edge for our `_PrismaMigration`. May be used by Relay 1. */
  _prismaMigrationEdge?: Maybe<_PrismaMigrationsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `_PrismaMigration` mutation. */
export type UpdatePrismaMigrationPayload_PrismaMigrationEdgeArgs = {
  orderBy?: InputMaybe<Array<_PrismaMigrationsOrderBy>>;
};

/** All input for the `updateShiftById` mutation. */
export type UpdateShiftByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Shift` being updated. */
  shiftPatch: ShiftPatch;
};

/** All input for the `updateShift` mutation. */
export type UpdateShiftInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Shift` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Shift` being updated. */
  shiftPatch: ShiftPatch;
};

/** The output of our update `Shift` mutation. */
export type UpdateShiftPayload = {
  __typename?: 'UpdateShiftPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `CustomShift` that is related to this `Shift`. */
  customShiftByCustomShiftId?: Maybe<CustomShift>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Shift` that was updated by this mutation. */
  shift?: Maybe<Shift>;
  /** An edge for our `Shift`. May be used by Relay 1. */
  shiftEdge?: Maybe<ShiftsEdge>;
  /** Reads a single `ShiftSetting` that is related to this `Shift`. */
  shiftSettingByShiftSettingId?: Maybe<ShiftSetting>;
  /** Reads a single `Workplace` that is related to this `Shift`. */
  workplaceByWorkplaceId?: Maybe<Workplace>;
  /** Reads a single `WorkplaceUser` that is related to this `Shift`. */
  workplaceUserByWorkplaceUserId?: Maybe<WorkplaceUser>;
};


/** The output of our update `Shift` mutation. */
export type UpdateShiftPayloadShiftEdgeArgs = {
  orderBy?: InputMaybe<Array<ShiftsOrderBy>>;
};

/** All input for the `updateShiftSettingById` mutation. */
export type UpdateShiftSettingByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ShiftSetting` being updated. */
  shiftSettingPatch: ShiftSettingPatch;
};

/** All input for the `updateShiftSetting` mutation. */
export type UpdateShiftSettingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ShiftSetting` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `ShiftSetting` being updated. */
  shiftSettingPatch: ShiftSettingPatch;
};

/** The output of our update `ShiftSetting` mutation. */
export type UpdateShiftSettingPayload = {
  __typename?: 'UpdateShiftSettingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `ShiftSetting` that was updated by this mutation. */
  shiftSetting?: Maybe<ShiftSetting>;
  /** An edge for our `ShiftSetting`. May be used by Relay 1. */
  shiftSettingEdge?: Maybe<ShiftSettingsEdge>;
  /** Reads a single `Workplace` that is related to this `ShiftSetting`. */
  workplaceByWorkplaceId?: Maybe<Workplace>;
};


/** The output of our update `ShiftSetting` mutation. */
export type UpdateShiftSettingPayloadShiftSettingEdgeArgs = {
  orderBy?: InputMaybe<Array<ShiftSettingsOrderBy>>;
};

/** All input for the `updateUserById` mutation. */
export type UpdateUserByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `User` being updated. */
  userPatch: UserPatch;
};

/** All input for the `updateUser` mutation. */
export type UpdateUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `User` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `User` being updated. */
  userPatch: UserPatch;
};

/** The output of our update `User` mutation. */
export type UpdateUserPayload = {
  __typename?: 'UpdateUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `User` that was updated by this mutation. */
  user?: Maybe<User>;
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge?: Maybe<UsersEdge>;
};


/** The output of our update `User` mutation. */
export type UpdateUserPayloadUserEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** All input for the `updateWorkplaceById` mutation. */
export type UpdateWorkplaceByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Workplace` being updated. */
  workplacePatch: WorkplacePatch;
};

/** All input for the `updateWorkplace` mutation. */
export type UpdateWorkplaceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Workplace` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Workplace` being updated. */
  workplacePatch: WorkplacePatch;
};

/** The output of our update `Workplace` mutation. */
export type UpdateWorkplacePayload = {
  __typename?: 'UpdateWorkplacePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Workplace` that was updated by this mutation. */
  workplace?: Maybe<Workplace>;
  /** An edge for our `Workplace`. May be used by Relay 1. */
  workplaceEdge?: Maybe<WorkplacesEdge>;
};


/** The output of our update `Workplace` mutation. */
export type UpdateWorkplacePayloadWorkplaceEdgeArgs = {
  orderBy?: InputMaybe<Array<WorkplacesOrderBy>>;
};

/** All input for the `updateWorkplaceUserById` mutation. */
export type UpdateWorkplaceUserByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `WorkplaceUser` being updated. */
  workplaceUserPatch: WorkplaceUserPatch;
};

/** All input for the `updateWorkplaceUser` mutation. */
export type UpdateWorkplaceUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `WorkplaceUser` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `WorkplaceUser` being updated. */
  workplaceUserPatch: WorkplaceUserPatch;
};

/** The output of our update `WorkplaceUser` mutation. */
export type UpdateWorkplaceUserPayload = {
  __typename?: 'UpdateWorkplaceUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `WorkplaceUser`. */
  userByUserId?: Maybe<User>;
  /** Reads a single `Workplace` that is related to this `WorkplaceUser`. */
  workplaceByWorkplaceId?: Maybe<Workplace>;
  /** The `WorkplaceUser` that was updated by this mutation. */
  workplaceUser?: Maybe<WorkplaceUser>;
  /** An edge for our `WorkplaceUser`. May be used by Relay 1. */
  workplaceUserEdge?: Maybe<WorkplaceUsersEdge>;
};


/** The output of our update `WorkplaceUser` mutation. */
export type UpdateWorkplaceUserPayloadWorkplaceUserEdgeArgs = {
  orderBy?: InputMaybe<Array<WorkplaceUsersOrderBy>>;
};

/** All input for the upsert `CustomShift` mutation. */
export type UpsertCustomShiftInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `CustomShift` to be upserted by this mutation. */
  customShift: CustomShiftInput;
};

/** The output of our upsert `CustomShift` mutation. */
export type UpsertCustomShiftPayload = {
  __typename?: 'UpsertCustomShiftPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `CustomShift` that was upserted by this mutation. */
  customShift?: Maybe<CustomShift>;
  /** An edge for our `CustomShift`. May be used by Relay 1. */
  customShiftEdge?: Maybe<CustomShiftsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Workplace` that is related to this `CustomShift`. */
  workplaceByWorkplaceId?: Maybe<Workplace>;
};


/** The output of our upsert `CustomShift` mutation. */
export type UpsertCustomShiftPayloadCustomShiftEdgeArgs = {
  orderBy?: InputMaybe<Array<CustomShiftsOrderBy>>;
};

/** Where conditions for the upsert `CustomShift` mutation. */
export type UpsertCustomShiftWhere = {
  id?: InputMaybe<Scalars['UUID']>;
};

/** All input for the upsert `Device` mutation. */
export type UpsertDeviceInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Device` to be upserted by this mutation. */
  device: DeviceInput;
};

/** The output of our upsert `Device` mutation. */
export type UpsertDevicePayload = {
  __typename?: 'UpsertDevicePayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Device` that was upserted by this mutation. */
  device?: Maybe<Device>;
  /** An edge for our `Device`. May be used by Relay 1. */
  deviceEdge?: Maybe<DevicesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Device`. */
  userByUserId?: Maybe<User>;
};


/** The output of our upsert `Device` mutation. */
export type UpsertDevicePayloadDeviceEdgeArgs = {
  orderBy?: InputMaybe<Array<DevicesOrderBy>>;
};

/** Where conditions for the upsert `Device` mutation. */
export type UpsertDeviceWhere = {
  id?: InputMaybe<Scalars['UUID']>;
};

/** All input for the upsert `Memo` mutation. */
export type UpsertMemoInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Memo` to be upserted by this mutation. */
  memo: MemoInput;
};

/** The output of our upsert `Memo` mutation. */
export type UpsertMemoPayload = {
  __typename?: 'UpsertMemoPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Memo` that was upserted by this mutation. */
  memo?: Maybe<Memo>;
  /** An edge for our `Memo`. May be used by Relay 1. */
  memoEdge?: Maybe<MemosEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Workplace` that is related to this `Memo`. */
  workplaceByWorkplaceId?: Maybe<Workplace>;
};


/** The output of our upsert `Memo` mutation. */
export type UpsertMemoPayloadMemoEdgeArgs = {
  orderBy?: InputMaybe<Array<MemosOrderBy>>;
};

/** Where conditions for the upsert `Memo` mutation. */
export type UpsertMemoWhere = {
  id?: InputMaybe<Scalars['UUID']>;
};

/** All input for the upsert `Pgmigration` mutation. */
export type UpsertPgmigrationInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Pgmigration` to be upserted by this mutation. */
  pgmigration: PgmigrationInput;
};

/** The output of our upsert `Pgmigration` mutation. */
export type UpsertPgmigrationPayload = {
  __typename?: 'UpsertPgmigrationPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Pgmigration` that was upserted by this mutation. */
  pgmigration?: Maybe<Pgmigration>;
  /** An edge for our `Pgmigration`. May be used by Relay 1. */
  pgmigrationEdge?: Maybe<PgmigrationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our upsert `Pgmigration` mutation. */
export type UpsertPgmigrationPayloadPgmigrationEdgeArgs = {
  orderBy?: InputMaybe<Array<PgmigrationsOrderBy>>;
};

/** Where conditions for the upsert `Pgmigration` mutation. */
export type UpsertPgmigrationWhere = {
  id?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `Shift` mutation. */
export type UpsertShiftInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Shift` to be upserted by this mutation. */
  shift: ShiftInput;
};

/** The output of our upsert `Shift` mutation. */
export type UpsertShiftPayload = {
  __typename?: 'UpsertShiftPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `CustomShift` that is related to this `Shift`. */
  customShiftByCustomShiftId?: Maybe<CustomShift>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Shift` that was upserted by this mutation. */
  shift?: Maybe<Shift>;
  /** An edge for our `Shift`. May be used by Relay 1. */
  shiftEdge?: Maybe<ShiftsEdge>;
  /** Reads a single `ShiftSetting` that is related to this `Shift`. */
  shiftSettingByShiftSettingId?: Maybe<ShiftSetting>;
  /** Reads a single `Workplace` that is related to this `Shift`. */
  workplaceByWorkplaceId?: Maybe<Workplace>;
  /** Reads a single `WorkplaceUser` that is related to this `Shift`. */
  workplaceUserByWorkplaceUserId?: Maybe<WorkplaceUser>;
};


/** The output of our upsert `Shift` mutation. */
export type UpsertShiftPayloadShiftEdgeArgs = {
  orderBy?: InputMaybe<Array<ShiftsOrderBy>>;
};

/** All input for the upsert `ShiftSetting` mutation. */
export type UpsertShiftSettingInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ShiftSetting` to be upserted by this mutation. */
  shiftSetting: ShiftSettingInput;
};

/** The output of our upsert `ShiftSetting` mutation. */
export type UpsertShiftSettingPayload = {
  __typename?: 'UpsertShiftSettingPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `ShiftSetting` that was upserted by this mutation. */
  shiftSetting?: Maybe<ShiftSetting>;
  /** An edge for our `ShiftSetting`. May be used by Relay 1. */
  shiftSettingEdge?: Maybe<ShiftSettingsEdge>;
  /** Reads a single `Workplace` that is related to this `ShiftSetting`. */
  workplaceByWorkplaceId?: Maybe<Workplace>;
};


/** The output of our upsert `ShiftSetting` mutation. */
export type UpsertShiftSettingPayloadShiftSettingEdgeArgs = {
  orderBy?: InputMaybe<Array<ShiftSettingsOrderBy>>;
};

/** Where conditions for the upsert `ShiftSetting` mutation. */
export type UpsertShiftSettingWhere = {
  id?: InputMaybe<Scalars['UUID']>;
};

/** Where conditions for the upsert `Shift` mutation. */
export type UpsertShiftWhere = {
  id?: InputMaybe<Scalars['UUID']>;
};

/** All input for the upsert `User` mutation. */
export type UpsertUserInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `User` to be upserted by this mutation. */
  user: UserInput;
};

/** The output of our upsert `User` mutation. */
export type UpsertUserPayload = {
  __typename?: 'UpsertUserPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `User` that was upserted by this mutation. */
  user?: Maybe<User>;
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge?: Maybe<UsersEdge>;
};


/** The output of our upsert `User` mutation. */
export type UpsertUserPayloadUserEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** Where conditions for the upsert `User` mutation. */
export type UpsertUserWhere = {
  id?: InputMaybe<Scalars['UUID']>;
};

/** All input for the upsert `Workplace` mutation. */
export type UpsertWorkplaceInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Workplace` to be upserted by this mutation. */
  workplace: WorkplaceInput;
};

/** The output of our upsert `Workplace` mutation. */
export type UpsertWorkplacePayload = {
  __typename?: 'UpsertWorkplacePayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Workplace` that was upserted by this mutation. */
  workplace?: Maybe<Workplace>;
  /** An edge for our `Workplace`. May be used by Relay 1. */
  workplaceEdge?: Maybe<WorkplacesEdge>;
};


/** The output of our upsert `Workplace` mutation. */
export type UpsertWorkplacePayloadWorkplaceEdgeArgs = {
  orderBy?: InputMaybe<Array<WorkplacesOrderBy>>;
};

/** All input for the upsert `WorkplaceUser` mutation. */
export type UpsertWorkplaceUserInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `WorkplaceUser` to be upserted by this mutation. */
  workplaceUser: WorkplaceUserInput;
};

/** The output of our upsert `WorkplaceUser` mutation. */
export type UpsertWorkplaceUserPayload = {
  __typename?: 'UpsertWorkplaceUserPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `WorkplaceUser`. */
  userByUserId?: Maybe<User>;
  /** Reads a single `Workplace` that is related to this `WorkplaceUser`. */
  workplaceByWorkplaceId?: Maybe<Workplace>;
  /** The `WorkplaceUser` that was upserted by this mutation. */
  workplaceUser?: Maybe<WorkplaceUser>;
  /** An edge for our `WorkplaceUser`. May be used by Relay 1. */
  workplaceUserEdge?: Maybe<WorkplaceUsersEdge>;
};


/** The output of our upsert `WorkplaceUser` mutation. */
export type UpsertWorkplaceUserPayloadWorkplaceUserEdgeArgs = {
  orderBy?: InputMaybe<Array<WorkplaceUsersOrderBy>>;
};

/** Where conditions for the upsert `WorkplaceUser` mutation. */
export type UpsertWorkplaceUserWhere = {
  id?: InputMaybe<Scalars['UUID']>;
};

/** Where conditions for the upsert `Workplace` mutation. */
export type UpsertWorkplaceWhere = {
  id?: InputMaybe<Scalars['UUID']>;
};

/** All input for the upsert `_PrismaMigration` mutation. */
export type Upsert_PrismaMigrationInput = {
  /** The `_PrismaMigration` to be upserted by this mutation. */
  _prismaMigration: _PrismaMigrationInput;
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our upsert `_PrismaMigration` mutation. */
export type Upsert_PrismaMigrationPayload = {
  __typename?: 'Upsert_PrismaMigrationPayload';
  /** The `_PrismaMigration` that was upserted by this mutation. */
  _prismaMigration?: Maybe<_PrismaMigration>;
  /** An edge for our `_PrismaMigration`. May be used by Relay 1. */
  _prismaMigrationEdge?: Maybe<_PrismaMigrationsEdge>;
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our upsert `_PrismaMigration` mutation. */
export type Upsert_PrismaMigrationPayload_PrismaMigrationEdgeArgs = {
  orderBy?: InputMaybe<Array<_PrismaMigrationsOrderBy>>;
};

/** Where conditions for the upsert `_PrismaMigration` mutation. */
export type Upsert_PrismaMigrationWhere = {
  id?: InputMaybe<Scalars['String']>;
};

export type User = Node & {
  __typename?: 'User';
  createdAt: Scalars['Datetime'];
  /** Reads and enables pagination through a set of `Device`. */
  devicesByUserId: DevicesConnection;
  id: Scalars['UUID'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  remainingAddableUserCount: Scalars['Int'];
  updatedAt: Scalars['Datetime'];
  /** Reads and enables pagination through a set of `WorkplaceUser`. */
  workplaceUsersByUserId: WorkplaceUsersConnection;
};


export type UserDevicesByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DeviceCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DevicesOrderBy>>;
};


export type UserWorkplaceUsersByUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<WorkplaceUserCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<WorkplaceUsersOrderBy>>;
};

/** A condition to be used against `User` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type UserCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
};

/** An input for mutations affecting `User` */
export type UserInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  remainingAddableUserCount?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Represents an update to a `User`. Fields that are set will be updated. */
export type UserPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  remainingAddableUserCount?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `User` values. */
export type UsersConnection = {
  __typename?: 'UsersConnection';
  /** A list of edges which contains the `User` and cursor to aid in pagination. */
  edges: Array<UsersEdge>;
  /** A list of `User` objects. */
  nodes: Array<User>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `User` edge in the connection. */
export type UsersEdge = {
  __typename?: 'UsersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `User` at the end of the edge. */
  node: User;
};

/** Methods to use when ordering `User`. */
export enum UsersOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type Workplace = Node & {
  __typename?: 'Workplace';
  createdAt: Scalars['Datetime'];
  /** Reads and enables pagination through a set of `CustomShift`. */
  customShiftsByWorkplaceId: CustomShiftsConnection;
  hexColor: Scalars['String'];
  id: Scalars['UUID'];
  /** Reads and enables pagination through a set of `Memo`. */
  memosByWorkplaceId: MemosConnection;
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  order: Scalars['Int'];
  /** Reads and enables pagination through a set of `ShiftSetting`. */
  shiftSettingsByWorkplaceId: ShiftSettingsConnection;
  /** Reads and enables pagination through a set of `Shift`. */
  shiftsByWorkplaceId: ShiftsConnection;
  updatedAt: Scalars['Datetime'];
  /** Reads and enables pagination through a set of `WorkplaceUser`. */
  workplaceUsersByWorkplaceId: WorkplaceUsersConnection;
};


export type WorkplaceCustomShiftsByWorkplaceIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CustomShiftCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CustomShiftsOrderBy>>;
};


export type WorkplaceMemosByWorkplaceIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MemoCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MemosOrderBy>>;
};


export type WorkplaceShiftSettingsByWorkplaceIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ShiftSettingCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ShiftSettingsOrderBy>>;
};


export type WorkplaceShiftsByWorkplaceIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ShiftCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ShiftsOrderBy>>;
};


export type WorkplaceWorkplaceUsersByWorkplaceIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<WorkplaceUserCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<WorkplaceUsersOrderBy>>;
};

/**
 * A condition to be used against `Workplace` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type WorkplaceCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
};

/** An input for mutations affecting `Workplace` */
export type WorkplaceInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  hexColor: Scalars['String'];
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  order: Scalars['Int'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Represents an update to a `Workplace`. Fields that are set will be updated. */
export type WorkplacePatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  hexColor?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export type WorkplaceUser = Node & {
  __typename?: 'WorkplaceUser';
  createdAt: Scalars['Datetime'];
  id: Scalars['UUID'];
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  order: Scalars['Int'];
  role: Scalars['String'];
  /** Reads and enables pagination through a set of `Shift`. */
  shiftsByWorkplaceUserId: ShiftsConnection;
  updatedAt: Scalars['Datetime'];
  /** Reads a single `User` that is related to this `WorkplaceUser`. */
  userByUserId?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
  /** Reads a single `Workplace` that is related to this `WorkplaceUser`. */
  workplaceByWorkplaceId?: Maybe<Workplace>;
  workplaceId: Scalars['UUID'];
};


export type WorkplaceUserShiftsByWorkplaceUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ShiftCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ShiftsOrderBy>>;
};

/**
 * A condition to be used against `WorkplaceUser` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type WorkplaceUserCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `workplaceId` field. */
  workplaceId?: InputMaybe<Scalars['UUID']>;
};

/** An input for mutations affecting `WorkplaceUser` */
export type WorkplaceUserInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  order: Scalars['Int'];
  role?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userId?: InputMaybe<Scalars['UUID']>;
  workplaceId: Scalars['UUID'];
};

/** Represents an update to a `WorkplaceUser`. Fields that are set will be updated. */
export type WorkplaceUserPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  role?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userId?: InputMaybe<Scalars['UUID']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `WorkplaceUser` values. */
export type WorkplaceUsersConnection = {
  __typename?: 'WorkplaceUsersConnection';
  /** A list of edges which contains the `WorkplaceUser` and cursor to aid in pagination. */
  edges: Array<WorkplaceUsersEdge>;
  /** A list of `WorkplaceUser` objects. */
  nodes: Array<WorkplaceUser>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `WorkplaceUser` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `WorkplaceUser` edge in the connection. */
export type WorkplaceUsersEdge = {
  __typename?: 'WorkplaceUsersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `WorkplaceUser` at the end of the edge. */
  node: WorkplaceUser;
};

/** Methods to use when ordering `WorkplaceUser`. */
export enum WorkplaceUsersOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC',
  WorkplaceIdAsc = 'WORKPLACE_ID_ASC',
  WorkplaceIdDesc = 'WORKPLACE_ID_DESC'
}

/** A connection to a list of `Workplace` values. */
export type WorkplacesConnection = {
  __typename?: 'WorkplacesConnection';
  /** A list of edges which contains the `Workplace` and cursor to aid in pagination. */
  edges: Array<WorkplacesEdge>;
  /** A list of `Workplace` objects. */
  nodes: Array<Workplace>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Workplace` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Workplace` edge in the connection. */
export type WorkplacesEdge = {
  __typename?: 'WorkplacesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Workplace` at the end of the edge. */
  node: Workplace;
};

/** Methods to use when ordering `Workplace`. */
export enum WorkplacesOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type _PrismaMigration = Node & {
  __typename?: '_PrismaMigration';
  appliedStepsCount: Scalars['Int'];
  checksum: Scalars['String'];
  finishedAt?: Maybe<Scalars['Datetime']>;
  id: Scalars['String'];
  logs?: Maybe<Scalars['String']>;
  migrationName: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  rolledBackAt?: Maybe<Scalars['Datetime']>;
  startedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `_PrismaMigration` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type _PrismaMigrationCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['String']>;
};

/** An input for mutations affecting `_PrismaMigration` */
export type _PrismaMigrationInput = {
  appliedStepsCount?: InputMaybe<Scalars['Int']>;
  checksum: Scalars['String'];
  finishedAt?: InputMaybe<Scalars['Datetime']>;
  id: Scalars['String'];
  logs?: InputMaybe<Scalars['String']>;
  migrationName: Scalars['String'];
  rolledBackAt?: InputMaybe<Scalars['Datetime']>;
  startedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Represents an update to a `_PrismaMigration`. Fields that are set will be updated. */
export type _PrismaMigrationPatch = {
  appliedStepsCount?: InputMaybe<Scalars['Int']>;
  checksum?: InputMaybe<Scalars['String']>;
  finishedAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['String']>;
  logs?: InputMaybe<Scalars['String']>;
  migrationName?: InputMaybe<Scalars['String']>;
  rolledBackAt?: InputMaybe<Scalars['Datetime']>;
  startedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `_PrismaMigration` values. */
export type _PrismaMigrationsConnection = {
  __typename?: '_PrismaMigrationsConnection';
  /** A list of edges which contains the `_PrismaMigration` and cursor to aid in pagination. */
  edges: Array<_PrismaMigrationsEdge>;
  /** A list of `_PrismaMigration` objects. */
  nodes: Array<_PrismaMigration>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `_PrismaMigration` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `_PrismaMigration` edge in the connection. */
export type _PrismaMigrationsEdge = {
  __typename?: '_PrismaMigrationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `_PrismaMigration` at the end of the edge. */
  node: _PrismaMigration;
};

/** Methods to use when ordering `_PrismaMigration`. */
export enum _PrismaMigrationsOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** All input for the create mn`CustomShift` mutation. */
export type MnCreateCustomShiftInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The one or many `CustomShift` to be created by this mutation. */
  mnCustomShift?: InputMaybe<Array<CustomShiftInput>>;
};

/** The output of our many create `CustomShift` mutation. */
export type MnCreateCustomShiftPayload = {
  __typename?: 'mnCreateCustomShiftPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `CustomShift` that was created by this mutation. */
  customShift?: Maybe<CustomShift>;
  /** An edge for our `CustomShift`. May be used by Relay 1. */
  customShiftEdge?: Maybe<CustomShiftsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Workplace` that is related to this `CustomShift`. */
  workplaceByWorkplaceId?: Maybe<Workplace>;
};


/** The output of our many create `CustomShift` mutation. */
export type MnCreateCustomShiftPayloadCustomShiftEdgeArgs = {
  orderBy?: InputMaybe<Array<CustomShiftsOrderBy>>;
};

/** All input for the create mn`Device` mutation. */
export type MnCreateDeviceInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The one or many `Device` to be created by this mutation. */
  mnDevice?: InputMaybe<Array<DeviceInput>>;
};

/** The output of our many create `Device` mutation. */
export type MnCreateDevicePayload = {
  __typename?: 'mnCreateDevicePayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Device` that was created by this mutation. */
  device?: Maybe<Device>;
  /** An edge for our `Device`. May be used by Relay 1. */
  deviceEdge?: Maybe<DevicesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Device`. */
  userByUserId?: Maybe<User>;
};


/** The output of our many create `Device` mutation. */
export type MnCreateDevicePayloadDeviceEdgeArgs = {
  orderBy?: InputMaybe<Array<DevicesOrderBy>>;
};

/** All input for the create mn`Memo` mutation. */
export type MnCreateMemoInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The one or many `Memo` to be created by this mutation. */
  mnMemo?: InputMaybe<Array<MemoInput>>;
};

/** The output of our many create `Memo` mutation. */
export type MnCreateMemoPayload = {
  __typename?: 'mnCreateMemoPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Memo` that was created by this mutation. */
  memo?: Maybe<Memo>;
  /** An edge for our `Memo`. May be used by Relay 1. */
  memoEdge?: Maybe<MemosEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Workplace` that is related to this `Memo`. */
  workplaceByWorkplaceId?: Maybe<Workplace>;
};


/** The output of our many create `Memo` mutation. */
export type MnCreateMemoPayloadMemoEdgeArgs = {
  orderBy?: InputMaybe<Array<MemosOrderBy>>;
};

/** All input for the create mn`Shift` mutation. */
export type MnCreateShiftInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The one or many `Shift` to be created by this mutation. */
  mnShift?: InputMaybe<Array<ShiftInput>>;
};

/** The output of our many create `Shift` mutation. */
export type MnCreateShiftPayload = {
  __typename?: 'mnCreateShiftPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `CustomShift` that is related to this `Shift`. */
  customShiftByCustomShiftId?: Maybe<CustomShift>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Shift` that was created by this mutation. */
  shift?: Maybe<Shift>;
  /** An edge for our `Shift`. May be used by Relay 1. */
  shiftEdge?: Maybe<ShiftsEdge>;
  /** Reads a single `ShiftSetting` that is related to this `Shift`. */
  shiftSettingByShiftSettingId?: Maybe<ShiftSetting>;
  /** Reads a single `Workplace` that is related to this `Shift`. */
  workplaceByWorkplaceId?: Maybe<Workplace>;
  /** Reads a single `WorkplaceUser` that is related to this `Shift`. */
  workplaceUserByWorkplaceUserId?: Maybe<WorkplaceUser>;
};


/** The output of our many create `Shift` mutation. */
export type MnCreateShiftPayloadShiftEdgeArgs = {
  orderBy?: InputMaybe<Array<ShiftsOrderBy>>;
};

/** All input for the create mn`ShiftSetting` mutation. */
export type MnCreateShiftSettingInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The one or many `ShiftSetting` to be created by this mutation. */
  mnShiftSetting?: InputMaybe<Array<ShiftSettingInput>>;
};

/** The output of our many create `ShiftSetting` mutation. */
export type MnCreateShiftSettingPayload = {
  __typename?: 'mnCreateShiftSettingPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `ShiftSetting` that was created by this mutation. */
  shiftSetting?: Maybe<ShiftSetting>;
  /** An edge for our `ShiftSetting`. May be used by Relay 1. */
  shiftSettingEdge?: Maybe<ShiftSettingsEdge>;
  /** Reads a single `Workplace` that is related to this `ShiftSetting`. */
  workplaceByWorkplaceId?: Maybe<Workplace>;
};


/** The output of our many create `ShiftSetting` mutation. */
export type MnCreateShiftSettingPayloadShiftSettingEdgeArgs = {
  orderBy?: InputMaybe<Array<ShiftSettingsOrderBy>>;
};

/** All input for the create mn`User` mutation. */
export type MnCreateUserInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The one or many `User` to be created by this mutation. */
  mnUser?: InputMaybe<Array<UserInput>>;
};

/** The output of our many create `User` mutation. */
export type MnCreateUserPayload = {
  __typename?: 'mnCreateUserPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `User` that was created by this mutation. */
  user?: Maybe<User>;
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge?: Maybe<UsersEdge>;
};


/** The output of our many create `User` mutation. */
export type MnCreateUserPayloadUserEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** All input for the create mn`Workplace` mutation. */
export type MnCreateWorkplaceInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The one or many `Workplace` to be created by this mutation. */
  mnWorkplace?: InputMaybe<Array<WorkplaceInput>>;
};

/** The output of our many create `Workplace` mutation. */
export type MnCreateWorkplacePayload = {
  __typename?: 'mnCreateWorkplacePayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Workplace` that was created by this mutation. */
  workplace?: Maybe<Workplace>;
  /** An edge for our `Workplace`. May be used by Relay 1. */
  workplaceEdge?: Maybe<WorkplacesEdge>;
};


/** The output of our many create `Workplace` mutation. */
export type MnCreateWorkplacePayloadWorkplaceEdgeArgs = {
  orderBy?: InputMaybe<Array<WorkplacesOrderBy>>;
};

/** All input for the create mn`WorkplaceUser` mutation. */
export type MnCreateWorkplaceUserInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The one or many `WorkplaceUser` to be created by this mutation. */
  mnWorkplaceUser?: InputMaybe<Array<WorkplaceUserInput>>;
};

/** The output of our many create `WorkplaceUser` mutation. */
export type MnCreateWorkplaceUserPayload = {
  __typename?: 'mnCreateWorkplaceUserPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `WorkplaceUser`. */
  userByUserId?: Maybe<User>;
  /** Reads a single `Workplace` that is related to this `WorkplaceUser`. */
  workplaceByWorkplaceId?: Maybe<Workplace>;
  /** The `WorkplaceUser` that was created by this mutation. */
  workplaceUser?: Maybe<WorkplaceUser>;
  /** An edge for our `WorkplaceUser`. May be used by Relay 1. */
  workplaceUserEdge?: Maybe<WorkplaceUsersEdge>;
};


/** The output of our many create `WorkplaceUser` mutation. */
export type MnCreateWorkplaceUserPayloadWorkplaceUserEdgeArgs = {
  orderBy?: InputMaybe<Array<WorkplaceUsersOrderBy>>;
};

/** All input for the delete `mnDeleteCustomShiftById` mutation. */
export type MnDeleteCustomShiftByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The one or many `CustomShift` to be deleted. You must provide the PK values! */
  mnCustomShiftPatch?: InputMaybe<Array<CustomShiftPatch>>;
};

/** The output of our delete mn `CustomShift` mutation. */
export type MnDeleteCustomShiftPayload = {
  __typename?: 'mnDeleteCustomShiftPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `CustomShift` that was deleted by this mutation. */
  customShift?: Maybe<CustomShift>;
  /** An edge for our `CustomShift`. May be used by Relay 1. */
  customShiftEdge?: Maybe<CustomShiftsEdge>;
  deletedCustomShiftId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Workplace` that is related to this `CustomShift`. */
  workplaceByWorkplaceId?: Maybe<Workplace>;
};


/** The output of our delete mn `CustomShift` mutation. */
export type MnDeleteCustomShiftPayloadCustomShiftEdgeArgs = {
  orderBy?: InputMaybe<Array<CustomShiftsOrderBy>>;
};

/** All input for the delete `mnDeleteDeviceById` mutation. */
export type MnDeleteDeviceByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The one or many `Device` to be deleted. You must provide the PK values! */
  mnDevicePatch?: InputMaybe<Array<DevicePatch>>;
};

/** The output of our delete mn `Device` mutation. */
export type MnDeleteDevicePayload = {
  __typename?: 'mnDeleteDevicePayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedDeviceId?: Maybe<Scalars['ID']>;
  /** The `Device` that was deleted by this mutation. */
  device?: Maybe<Device>;
  /** An edge for our `Device`. May be used by Relay 1. */
  deviceEdge?: Maybe<DevicesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Device`. */
  userByUserId?: Maybe<User>;
};


/** The output of our delete mn `Device` mutation. */
export type MnDeleteDevicePayloadDeviceEdgeArgs = {
  orderBy?: InputMaybe<Array<DevicesOrderBy>>;
};

/** All input for the delete `mnDeleteMemoById` mutation. */
export type MnDeleteMemoByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The one or many `Memo` to be deleted. You must provide the PK values! */
  mnMemoPatch?: InputMaybe<Array<MemoPatch>>;
};

/** The output of our delete mn `Memo` mutation. */
export type MnDeleteMemoPayload = {
  __typename?: 'mnDeleteMemoPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedMemoId?: Maybe<Scalars['ID']>;
  /** The `Memo` that was deleted by this mutation. */
  memo?: Maybe<Memo>;
  /** An edge for our `Memo`. May be used by Relay 1. */
  memoEdge?: Maybe<MemosEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Workplace` that is related to this `Memo`. */
  workplaceByWorkplaceId?: Maybe<Workplace>;
};


/** The output of our delete mn `Memo` mutation. */
export type MnDeleteMemoPayloadMemoEdgeArgs = {
  orderBy?: InputMaybe<Array<MemosOrderBy>>;
};

/** All input for the delete `mnDeleteShiftById` mutation. */
export type MnDeleteShiftByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The one or many `Shift` to be deleted. You must provide the PK values! */
  mnShiftPatch?: InputMaybe<Array<ShiftPatch>>;
};

/** The output of our delete mn `Shift` mutation. */
export type MnDeleteShiftPayload = {
  __typename?: 'mnDeleteShiftPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `CustomShift` that is related to this `Shift`. */
  customShiftByCustomShiftId?: Maybe<CustomShift>;
  deletedShiftId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Shift` that was deleted by this mutation. */
  shift?: Maybe<Shift>;
  /** An edge for our `Shift`. May be used by Relay 1. */
  shiftEdge?: Maybe<ShiftsEdge>;
  /** Reads a single `ShiftSetting` that is related to this `Shift`. */
  shiftSettingByShiftSettingId?: Maybe<ShiftSetting>;
  /** Reads a single `Workplace` that is related to this `Shift`. */
  workplaceByWorkplaceId?: Maybe<Workplace>;
  /** Reads a single `WorkplaceUser` that is related to this `Shift`. */
  workplaceUserByWorkplaceUserId?: Maybe<WorkplaceUser>;
};


/** The output of our delete mn `Shift` mutation. */
export type MnDeleteShiftPayloadShiftEdgeArgs = {
  orderBy?: InputMaybe<Array<ShiftsOrderBy>>;
};

/** All input for the delete `mnDeleteShiftSettingById` mutation. */
export type MnDeleteShiftSettingByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The one or many `ShiftSetting` to be deleted. You must provide the PK values! */
  mnShiftSettingPatch?: InputMaybe<Array<ShiftSettingPatch>>;
};

/** The output of our delete mn `ShiftSetting` mutation. */
export type MnDeleteShiftSettingPayload = {
  __typename?: 'mnDeleteShiftSettingPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedShiftSettingId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `ShiftSetting` that was deleted by this mutation. */
  shiftSetting?: Maybe<ShiftSetting>;
  /** An edge for our `ShiftSetting`. May be used by Relay 1. */
  shiftSettingEdge?: Maybe<ShiftSettingsEdge>;
  /** Reads a single `Workplace` that is related to this `ShiftSetting`. */
  workplaceByWorkplaceId?: Maybe<Workplace>;
};


/** The output of our delete mn `ShiftSetting` mutation. */
export type MnDeleteShiftSettingPayloadShiftSettingEdgeArgs = {
  orderBy?: InputMaybe<Array<ShiftSettingsOrderBy>>;
};

/** All input for the delete `mnDeleteUserById` mutation. */
export type MnDeleteUserByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The one or many `User` to be deleted. You must provide the PK values! */
  mnUserPatch?: InputMaybe<Array<UserPatch>>;
};

/** The output of our delete mn `User` mutation. */
export type MnDeleteUserPayload = {
  __typename?: 'mnDeleteUserPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedUserId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `User` that was deleted by this mutation. */
  user?: Maybe<User>;
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge?: Maybe<UsersEdge>;
};


/** The output of our delete mn `User` mutation. */
export type MnDeleteUserPayloadUserEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** All input for the delete `mnDeleteWorkplaceById` mutation. */
export type MnDeleteWorkplaceByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The one or many `Workplace` to be deleted. You must provide the PK values! */
  mnWorkplacePatch?: InputMaybe<Array<WorkplacePatch>>;
};

/** The output of our delete mn `Workplace` mutation. */
export type MnDeleteWorkplacePayload = {
  __typename?: 'mnDeleteWorkplacePayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedWorkplaceId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Workplace` that was deleted by this mutation. */
  workplace?: Maybe<Workplace>;
  /** An edge for our `Workplace`. May be used by Relay 1. */
  workplaceEdge?: Maybe<WorkplacesEdge>;
};


/** The output of our delete mn `Workplace` mutation. */
export type MnDeleteWorkplacePayloadWorkplaceEdgeArgs = {
  orderBy?: InputMaybe<Array<WorkplacesOrderBy>>;
};

/** All input for the delete `mnDeleteWorkplaceUserById` mutation. */
export type MnDeleteWorkplaceUserByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The one or many `WorkplaceUser` to be deleted. You must provide the PK values! */
  mnWorkplaceUserPatch?: InputMaybe<Array<WorkplaceUserPatch>>;
};

/** The output of our delete mn `WorkplaceUser` mutation. */
export type MnDeleteWorkplaceUserPayload = {
  __typename?: 'mnDeleteWorkplaceUserPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedWorkplaceUserId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `WorkplaceUser`. */
  userByUserId?: Maybe<User>;
  /** Reads a single `Workplace` that is related to this `WorkplaceUser`. */
  workplaceByWorkplaceId?: Maybe<Workplace>;
  /** The `WorkplaceUser` that was deleted by this mutation. */
  workplaceUser?: Maybe<WorkplaceUser>;
  /** An edge for our `WorkplaceUser`. May be used by Relay 1. */
  workplaceUserEdge?: Maybe<WorkplaceUsersEdge>;
};


/** The output of our delete mn `WorkplaceUser` mutation. */
export type MnDeleteWorkplaceUserPayloadWorkplaceUserEdgeArgs = {
  orderBy?: InputMaybe<Array<WorkplaceUsersOrderBy>>;
};

/** All input for the update `mnUpdateCustomShiftById` mutation. */
export type MnUpdateCustomShiftByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The one or many `CustomShift` to be updated. */
  mnCustomShiftPatch?: InputMaybe<Array<CustomShiftPatch>>;
};

/** The output of our update mn `CustomShift` mutation. */
export type MnUpdateCustomShiftPayload = {
  __typename?: 'mnUpdateCustomShiftPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input,                 unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `CustomShift` that was updated by this mutation. */
  customShift?: Maybe<CustomShift>;
  /** An edge for our `CustomShift`. May be used by Relay 1. */
  customShiftEdge?: Maybe<CustomShiftsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Workplace` that is related to this `CustomShift`. */
  workplaceByWorkplaceId?: Maybe<Workplace>;
};


/** The output of our update mn `CustomShift` mutation. */
export type MnUpdateCustomShiftPayloadCustomShiftEdgeArgs = {
  orderBy?: InputMaybe<Array<CustomShiftsOrderBy>>;
};

/** All input for the update `mnUpdateDeviceById` mutation. */
export type MnUpdateDeviceByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The one or many `Device` to be updated. */
  mnDevicePatch?: InputMaybe<Array<DevicePatch>>;
};

/** The output of our update mn `Device` mutation. */
export type MnUpdateDevicePayload = {
  __typename?: 'mnUpdateDevicePayload';
  /** The exact same `clientMutationId` that was provided in the mutation input,                 unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Device` that was updated by this mutation. */
  device?: Maybe<Device>;
  /** An edge for our `Device`. May be used by Relay 1. */
  deviceEdge?: Maybe<DevicesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Device`. */
  userByUserId?: Maybe<User>;
};


/** The output of our update mn `Device` mutation. */
export type MnUpdateDevicePayloadDeviceEdgeArgs = {
  orderBy?: InputMaybe<Array<DevicesOrderBy>>;
};

/** All input for the update `mnUpdateMemoById` mutation. */
export type MnUpdateMemoByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The one or many `Memo` to be updated. */
  mnMemoPatch?: InputMaybe<Array<MemoPatch>>;
};

/** The output of our update mn `Memo` mutation. */
export type MnUpdateMemoPayload = {
  __typename?: 'mnUpdateMemoPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input,                 unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Memo` that was updated by this mutation. */
  memo?: Maybe<Memo>;
  /** An edge for our `Memo`. May be used by Relay 1. */
  memoEdge?: Maybe<MemosEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Workplace` that is related to this `Memo`. */
  workplaceByWorkplaceId?: Maybe<Workplace>;
};


/** The output of our update mn `Memo` mutation. */
export type MnUpdateMemoPayloadMemoEdgeArgs = {
  orderBy?: InputMaybe<Array<MemosOrderBy>>;
};

/** All input for the update `mnUpdateShiftById` mutation. */
export type MnUpdateShiftByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The one or many `Shift` to be updated. */
  mnShiftPatch?: InputMaybe<Array<ShiftPatch>>;
};

/** The output of our update mn `Shift` mutation. */
export type MnUpdateShiftPayload = {
  __typename?: 'mnUpdateShiftPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input,                 unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `CustomShift` that is related to this `Shift`. */
  customShiftByCustomShiftId?: Maybe<CustomShift>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Shift` that was updated by this mutation. */
  shift?: Maybe<Shift>;
  /** An edge for our `Shift`. May be used by Relay 1. */
  shiftEdge?: Maybe<ShiftsEdge>;
  /** Reads a single `ShiftSetting` that is related to this `Shift`. */
  shiftSettingByShiftSettingId?: Maybe<ShiftSetting>;
  /** Reads a single `Workplace` that is related to this `Shift`. */
  workplaceByWorkplaceId?: Maybe<Workplace>;
  /** Reads a single `WorkplaceUser` that is related to this `Shift`. */
  workplaceUserByWorkplaceUserId?: Maybe<WorkplaceUser>;
};


/** The output of our update mn `Shift` mutation. */
export type MnUpdateShiftPayloadShiftEdgeArgs = {
  orderBy?: InputMaybe<Array<ShiftsOrderBy>>;
};

/** All input for the update `mnUpdateShiftSettingById` mutation. */
export type MnUpdateShiftSettingByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The one or many `ShiftSetting` to be updated. */
  mnShiftSettingPatch?: InputMaybe<Array<ShiftSettingPatch>>;
};

/** The output of our update mn `ShiftSetting` mutation. */
export type MnUpdateShiftSettingPayload = {
  __typename?: 'mnUpdateShiftSettingPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input,                 unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `ShiftSetting` that was updated by this mutation. */
  shiftSetting?: Maybe<ShiftSetting>;
  /** An edge for our `ShiftSetting`. May be used by Relay 1. */
  shiftSettingEdge?: Maybe<ShiftSettingsEdge>;
  /** Reads a single `Workplace` that is related to this `ShiftSetting`. */
  workplaceByWorkplaceId?: Maybe<Workplace>;
};


/** The output of our update mn `ShiftSetting` mutation. */
export type MnUpdateShiftSettingPayloadShiftSettingEdgeArgs = {
  orderBy?: InputMaybe<Array<ShiftSettingsOrderBy>>;
};

/** All input for the update `mnUpdateUserById` mutation. */
export type MnUpdateUserByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The one or many `User` to be updated. */
  mnUserPatch?: InputMaybe<Array<UserPatch>>;
};

/** The output of our update mn `User` mutation. */
export type MnUpdateUserPayload = {
  __typename?: 'mnUpdateUserPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input,                 unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `User` that was updated by this mutation. */
  user?: Maybe<User>;
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge?: Maybe<UsersEdge>;
};


/** The output of our update mn `User` mutation. */
export type MnUpdateUserPayloadUserEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** All input for the update `mnUpdateWorkplaceById` mutation. */
export type MnUpdateWorkplaceByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The one or many `Workplace` to be updated. */
  mnWorkplacePatch?: InputMaybe<Array<WorkplacePatch>>;
};

/** The output of our update mn `Workplace` mutation. */
export type MnUpdateWorkplacePayload = {
  __typename?: 'mnUpdateWorkplacePayload';
  /** The exact same `clientMutationId` that was provided in the mutation input,                 unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Workplace` that was updated by this mutation. */
  workplace?: Maybe<Workplace>;
  /** An edge for our `Workplace`. May be used by Relay 1. */
  workplaceEdge?: Maybe<WorkplacesEdge>;
};


/** The output of our update mn `Workplace` mutation. */
export type MnUpdateWorkplacePayloadWorkplaceEdgeArgs = {
  orderBy?: InputMaybe<Array<WorkplacesOrderBy>>;
};

/** All input for the update `mnUpdateWorkplaceUserById` mutation. */
export type MnUpdateWorkplaceUserByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The one or many `WorkplaceUser` to be updated. */
  mnWorkplaceUserPatch?: InputMaybe<Array<WorkplaceUserPatch>>;
};

/** The output of our update mn `WorkplaceUser` mutation. */
export type MnUpdateWorkplaceUserPayload = {
  __typename?: 'mnUpdateWorkplaceUserPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input,                 unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `WorkplaceUser`. */
  userByUserId?: Maybe<User>;
  /** Reads a single `Workplace` that is related to this `WorkplaceUser`. */
  workplaceByWorkplaceId?: Maybe<Workplace>;
  /** The `WorkplaceUser` that was updated by this mutation. */
  workplaceUser?: Maybe<WorkplaceUser>;
  /** An edge for our `WorkplaceUser`. May be used by Relay 1. */
  workplaceUserEdge?: Maybe<WorkplaceUsersEdge>;
};


/** The output of our update mn `WorkplaceUser` mutation. */
export type MnUpdateWorkplaceUserPayloadWorkplaceUserEdgeArgs = {
  orderBy?: InputMaybe<Array<WorkplaceUsersOrderBy>>;
};

export type GetWorkplaceUsersByWorkplaceIdQueryVariables = Exact<{
  workplaceId: Scalars['UUID'];
}>;


export type GetWorkplaceUsersByWorkplaceIdQuery = { __typename?: 'Query', workplaceById?: { __typename?: 'Workplace', name: string, workplaceUsersByWorkplaceId: { __typename?: 'WorkplaceUsersConnection', edges: Array<{ __typename?: 'WorkplaceUsersEdge', node: { __typename?: 'WorkplaceUser', id: any, userId?: any | null, workplaceId: any, name: string, role: string, order: number, createdAt: any } }> } } | null };

export type SelectMemosByWorkplaceIdAndYearAndMonthAndStartDayMutationVariables = Exact<{
  input: SelectMemosByWorkplaceIdAndYearAndMonthAndStartDayInput;
}>;


export type SelectMemosByWorkplaceIdAndYearAndMonthAndStartDayMutation = { __typename?: 'Mutation', selectMemosByWorkplaceIdAndYearAndMonthAndStartDay?: { __typename?: 'SelectMemosByWorkplaceIdAndYearAndMonthAndStartDayPayload', memos?: Array<{ __typename?: 'Memo', date: any, createdAt: any, id: any, updatedAt: any, workplaceId: any, content: string }> | null } | null };

export type SelectShiftsByWorkplaceIdAndYearAndMonthAndStartDayMutationVariables = Exact<{
  input: SelectShiftsByWorkplaceIdAndYearAndMonthAndStartDayInput;
}>;


export type SelectShiftsByWorkplaceIdAndYearAndMonthAndStartDayMutation = { __typename?: 'Mutation', selectShiftsByWorkplaceIdAndYearAndMonthAndStartDay?: { __typename?: 'SelectShiftsByWorkplaceIdAndYearAndMonthAndStartDayPayload', shifts?: Array<{ __typename?: 'Shift', createdAt: any, date: any, id: any, shiftSettingId?: any | null, workplaceUserId: any, workplaceId: any, shiftSettingByShiftSettingId?: { __typename?: 'ShiftSetting', id: any, name: string, hexColor: string } | null, customShiftByCustomShiftId?: { __typename?: 'CustomShift', id: any, name: string, hexColor: string } | null }> | null } | null };


export const GetWorkplaceUsersByWorkplaceIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetWorkplaceUsersByWorkplaceId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workplaceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workplaceById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workplaceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"workplaceUsersByWorkplaceId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"workplaceId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetWorkplaceUsersByWorkplaceIdQuery, GetWorkplaceUsersByWorkplaceIdQueryVariables>;
export const SelectMemosByWorkplaceIdAndYearAndMonthAndStartDayDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SelectMemosByWorkplaceIdAndYearAndMonthAndStartDay"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SelectMemosByWorkplaceIdAndYearAndMonthAndStartDayInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"selectMemosByWorkplaceIdAndYearAndMonthAndStartDay"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"memos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"workplaceId"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}}]}}]} as unknown as DocumentNode<SelectMemosByWorkplaceIdAndYearAndMonthAndStartDayMutation, SelectMemosByWorkplaceIdAndYearAndMonthAndStartDayMutationVariables>;
export const SelectShiftsByWorkplaceIdAndYearAndMonthAndStartDayDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SelectShiftsByWorkplaceIdAndYearAndMonthAndStartDay"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SelectShiftsByWorkplaceIdAndYearAndMonthAndStartDayInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"selectShiftsByWorkplaceIdAndYearAndMonthAndStartDay"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shifts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shiftSettingByShiftSettingId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"hexColor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customShiftByCustomShiftId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"hexColor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shiftSettingId"}},{"kind":"Field","name":{"kind":"Name","value":"workplaceUserId"}},{"kind":"Field","name":{"kind":"Name","value":"workplaceId"}}]}}]}}]}}]} as unknown as DocumentNode<SelectShiftsByWorkplaceIdAndYearAndMonthAndStartDayMutation, SelectShiftsByWorkplaceIdAndYearAndMonthAndStartDayMutationVariables>;